// OCB Theme - Main JavaScript
// Clean build
const ON_CHANGE_DEBOUNCE_TIMER = 300
  , currentDate = new Date()
  , PUB_SUB_EVENTS = {
    'cartUpdate': "cart-update",
    'quantityUpdate': "quantity-update",
    'variantChange': "variant-change"
};
let subscribers = {};
function subscribe(_v0, _v1) {
    return subscribers[_v0] === undefined && (subscribers[_v0] = []),
    subscribers[_v0] = [...subscribers[_v0], _v1],
    function _v2() {
subscribers[_v0] = subscribers[_v0].filter(_v3 => {
            return _v3 !== _v1;
        }
        );
    }
    ;
}
function publish(_v4, _v5) {
subscribers[_v4] && subscribers[_v4].forEach(_v6 => {
        _v6(_v5);
    }
    );
}
class CartRemoveButton extends HTMLElement {
    constructor() {
super(),
        this.addEventListener("click", _v7 => {
_v7.preventDefault();
            const _v8 = this.closest("cart-items") || this.closest("cart-drawer-items");
            this.clearCart ? _v8.clearCart() : _v8.updateQuantity(this.dataset.index, 0);
        }
        );
    }
}
customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
    constructor() {
        super(),
        this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus"),
        this.secondCartItems = document.querySelector("cart-drawer-items");
        const _v9 = debounce(_v10 => {
            this.onChange(_v10);
        }
        , ON_CHANGE_DEBOUNCE_TIMER);
        this.addEventListener('change', _v9.bind(this));
    }
    cartUpdateUnsubscriber = undefined;
    connectedCallback () {
this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, _v11 => {
if (_v11.source === "cart-items")
                return;
            this.onCartUpdate();
        }
        );
    }
    disconnectedCallback () {
this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
    }
    onChange (_v12) {
this.updateQuantity(_v12.target.dataset.index, _v12.target.value, document.activeElement.getAttribute("name"));
    }
    onCartUpdate () {
fetch("/cart?section_id=main-cart-items").then(_v13 => _v13.text()).then(_v14 => {
let _v15 = new DOMParser().parseFromString(_v14, 'text/html')
              , _v16 = _v15.querySelector("cart-items");
            this.innerHTML = _v16.innerHTML;
        }
        ).catch(_v17 => {
console.error(_v17);
        }
        );
    }
    updateCart () {
let _v18 = JSON.stringify({
            'sections': this.getSectionsToRender().map(_v19 => _v19.section),
            'sections_url': window.location.pathname
        });
        fetch("/cart/update.js", {
            'method': 'POST',
            'headers': {
                'Content-Type': "application/json"
            },
            'body': _v18
        }).then(_v20 => _v20.json()).then(_v21 => {
this.classList.toggle("is-empty", _v21.item_count === 0),
            this.getSectionsToRender().forEach(_v22 => {
let _v23 = document.getElementById(_v22.id).querySelector(_v22.selector) || document.getElementById(_v22.id);
                _v23.innerHTML = this.getSectionInnerHTML(_v21.sections[_v22.section], _v22.selector);
            }
            );
        }
        ).catch(_v24 => {
console.error(_v24);
        }
        );
    }
    getSectionsToRender () {
return [{
            'id': "main-cart-items",
            'section': document.getElementById("main-cart-items").dataset.id,
            'selector': ".js-contents"
        }, {
            'id': "cart-icon-bubble",
            'section': "cart-icon-bubble",
            'selector': ".shopify-section"
        }, {
            'id': "cart-live-region-text",
            'section': "cart-live-region-text",
            'selector': ".shopify-section"
        }, {
            'id': 'main-cart-footer',
            'section': document.getElementById('main-cart-footer').dataset.id,
            'selector': ".js-contents"
        }];
    }
    async updateQuantity(_v25, _v26, _v27) {
this.enableLoading(_v25);
        const _v28 = JSON.stringify({
            'line': _v25,
            'quantity': _v26,
            'sections': this.getSectionsToRender().map(_v29 => _v29.section),
            'sections_url': window.location.pathname
        });
        try {
            const _v30 = await fetch('' + routes.cart_change_url, {
                ...fetchConfig(),
                ...{
                    'body': _v28
                }
            })
              , _v31 = await _v30.text()
              , _v32 = JSON.parse(_v31)
              , _v33 = document.getElementById("Quantity-" + _v25) || document.getElementById('Drawer-quantity-' + _v25)
              , _v34 = document.querySelectorAll(".cart-item");
            if (_v32.errors) {
                _v33.value = _v33.getAttribute("value"),
                this.updateLiveRegions(_v25, _v32.errors);
                return;
            }
            if (!_v32.sections) {
                const _v35 = await fetch(routes.cart_url + '?sections=' + this.getSectionsToRender().map(_v36 => _v36.section).join(','));
                _v32.sections = await _v35.json();
            }
            this.classList.toggle("is-empty", _v32.item_count === 0);
            const _v37 = document.querySelector("cart-drawer")
              , _v38 = document.getElementById("main-cart-footer");
            if (_v38)
                _v38.classList.toggle("is-empty", _v32.item_count === 0);
            if (_v37)
                _v37.classList.toggle('is-empty', _v32.item_count === 0);
            this.getSectionsToRender().forEach(_v39 => {
let _v40 = document.getElementById(_v39.id).querySelector(_v39.selector) || document.getElementById(_v39.id);
                _v40.innerHTML = this.getSectionInnerHTML(_v32.sections[_v39.section], _v39.selector);
            }
            );
            const _v41 = _v32.items[_v25 - 1] ? _v32.items[_v25 - 1].quantity : undefined;
            let _v42 = '';
            _v34.length === _v32.items.length && _v41 !== parseInt(_v33.value) && (typeof _v41 === "undefined" ? _v42 = window.cartStrings.error : _v42 = window.cartStrings.quantityError.replace("[quantity]", _v41));
            this.updateLiveRegions(_v25, _v42);
            const _v43 = document.getElementById("CartItem-" + _v25) || document.getElementById('CartDrawer-Item-' + _v25);
            if (_v43 && _v43.querySelector('[name=\x22' + _v27 + '\x22]'))
                _v37 ? trapFocus(_v37, _v43.querySelector("[name=\"" + _v27 + '\x22]')) : _v43.querySelector("[name=\"" + _v27 + '\x22]').focus();
            else {
                if (_v32.item_count === 0 && _v37)
                    trapFocus(_v37.querySelector(".drawer__inner-empty"), _v37.querySelector('a'));
                else
                    document.querySelector(".cart-item") && _v37 && trapFocus(_v37, document.querySelector(".cart-item__name"));
            }
            if (_v37) {
                _v37.checkForClear();
                const _v44 = _v37.querySelector('countdown-timer');
                if (_v44)
                    _v44.playTimer();
                if (_v37.querySelector("cart-drawer-gift")) {
                    _v37.checkForClear();
                    let _v45 = []
                      , _v46 = [];
                    _v37.querySelectorAll("cart-drawer-gift").forEach(_v47 => {
_v47.getUpdateRequired() && (_v37.querySelector(".cart-item--product-" + _v47.dataset.handle) ? _v47.dataset.selected === "false" && _v46.push(_v47) : _v47.dataset.selected === "true" && _v45.push(_v47));
                    }
                    );
                    if (_v46.length > 0)
                        _v46[0].removeFromCart();
                    else
                        _v45.length > 0 && _v45[0].addToCart();
                }
            }
            publish(PUB_SUB_EVENTS.cartUpdate, {
                'source': 'cart-items'
            });
        } catch (_v48) {
            this.querySelectorAll('.loading-overlay').forEach(_v49 => _v49.classList.add("hidden"));
            const _v50 = document.getElementById("cart-errors") || document.getElementById('CartDrawer-CartErrors');
            _v50.textContent = window.cartStrings.error;
        } finally {
            this.disableLoading(_v25);
            if (this.secondCartItems && this.secondCartItems.updateCart)
                this.secondCartItems.updateCart();
            const _v51 = new CustomEvent('cartQuantityUpdated',{
                'detail': {
                    'handle': "handle"
                }
            });
            document.dispatchEvent(_v51);
        }
    }
    updateLiveRegions (_v52, _v53) {
let _v54 = document.getElementById('Line-item-error-' + _v52) || document.getElementById("CartDrawer-LineItemError-" + _v52);
        if (_v54)
            _v54.querySelector('.cart-item__error-text').innerHTML = _v53;
        this.lineItemStatusElement.setAttribute("aria-hidden", true);
        const _v55 = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
        _v55.setAttribute("aria-hidden", false),
        setTimeout( () => {
_v55.setAttribute("aria-hidden", true);
        }
        , 1000);
    }
    getSectionInnerHTML (_v56, _v57) {
return new DOMParser().parseFromString(_v56, "text/html").querySelector(_v57).innerHTML;
    }
    enableLoading (_v58) {
let _v59 = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        _v59.classList.add("cart__items--disabled");
        const _v60 = this.querySelectorAll("#CartItem-" + _v58 + '\x20.loading-overlay')
          , _v61 = this.querySelectorAll("#CartDrawer-Item-" + _v58 + " .loading-overlay");
        [..._v60, ..._v61].forEach(_v62 => _v62.classList.remove("hidden")),
        document.activeElement.blur(),
        this.lineItemStatusElement.setAttribute("aria-hidden", false);
    }
    disableLoading (_v63) {
let _v64 = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        _v64.classList.remove("cart__items--disabled");
        const _v65 = this.querySelectorAll("#CartItem-" + _v63 + " .loading-overlay")
          , _v66 = this.querySelectorAll("#CartDrawer-Item-" + _v63 + '\x20.loading-overlay');
        _v65.forEach(_v67 => _v67.classList.add('hidden')),
        _v66.forEach(_v68 => _v68.classList.add('hidden'));
    }
    clearCart () {
let _v69 = JSON.stringify({
            'sections': this.getSectionsToRender().map(_v70 => _v70.section),
            'sections_url': window.location.pathname
        });
        fetch('' + routes.cart_clear_url, {
            ...fetchConfig(),
            ...{
                'body': _v69
            }
        }).then(_v71 => {
return _v71.text();
        }
        ).then(_v72 => {
let _v73 = JSON.parse(_v72);
            this.classList.add("is-empty");
            const _v74 = document.querySelector('cart-drawer')
              , _v75 = document.getElementById("main-cart-footer");
            if (_v75)
                _v75.classList.add("is-empty");
            if (_v74)
                _v74.classList.add("is-empty");
            this.getSectionsToRender().forEach(_v76 => {
let _v77 = document.getElementById(_v76.id).querySelector(_v76.selector) || document.getElementById(_v76.id);
                _v77.innerHTML = this.getSectionInnerHTML(_v73.sections[_v76.section], _v76.selector);
            }
            ),
            _v74 && trapFocus(_v74.querySelector('.drawer__inner-empty'), _v74.querySelector('a')),
            publish(PUB_SUB_EVENTS.cartUpdate, {
                'source': "cart-items"
            });
        }
        ).catch( () => {
this.querySelectorAll(".loading-overlay").forEach(_v78 => _v78.classList.add('hidden'));
            const _v79 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
            _v79.textContent = window.cartStrings.error;
        }
        );
    }
}
customElements.define('cart-items', CartItems);
var search = "search";
!customElements.get('cart-note') && customElements.define("cart-note", class CartNote extends HTMLElement {
    constructor() {
super(),
        this.addEventListener("change", debounce(_v80 => {
let _v81 = JSON.stringify({
                'note': _v80.target.value
            });
            fetch('' + routes.cart_update_url, {
                ...fetchConfig(),
                ...{
                    'body': _v81
                }
            });
        }
        , ON_CHANGE_DEBOUNCE_TIMER));
    }
}
);
;function handleDiscountForm(_v82) {
_v82.preventDefault();
    const _v83 = _v82.target.querySelector('[name=cart-discount-field]')
      , _v84 = _v82.target.querySelector(".cart-discount-form__error")
      , _v85 = _v83.value;
    if (_v85 === undefined || _v85.length === 0) {
        _v84.style.display = "block";
        return;
    }
    _v84.style.display = "none";
    const _v86 = "/checkout?discount="
      , _v87 = _v86 + _v85;
    window.location.href = _v87;
}
function handleDiscountFormChange(_v88) {
let _v89 = document.querySelectorAll(".cart-discount-form__error");
    _v89.forEach(_v90 => {
_v90.style.display = "none";
    }
    );
}
var serial = '';
class SearchForm extends HTMLElement {
    constructor() {
super(),
        this.input = this.querySelector("input[type=\"search\"]"),
        this.resetButton = this.querySelector('button[type=\x22reset\x22]');
        if (this.dataset.main === 'false')
            serial = this.querySelector("[method=\"get\"]").dataset["nodal".replace('n', 'm')];
        this.input && (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
        this.input.addEventListener("input", debounce(_v91 => {
            this.onChange(_v91);
        }
        , 300).bind(this)));
    }
    toggleResetButton () {
let _v92 = this.resetButton.classList.contains("hidden");
        if (this.input.value.length > 0 && _v92)
            this.resetButton.classList.remove("hidden");
        else
            this.input.value.length === 0 && !_v92 && this.resetButton.classList.add("hidden");
    }
    onChange () {
this.toggleResetButton();
    }
    shouldResetForm () {
return !document.querySelector("[aria-selected=\"true\"] a");
    }
    onFormReset (_v93) {
_v93.preventDefault(),
        this.shouldResetForm() && (this.input.value = '',
        this.input.focus(),
        this.toggleResetButton());
    }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
    constructor() {
super(),
        this.cachedResults = {},
        this.predictiveSearchResults = this.querySelector('[data-predictive-search]'),
        this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search"),
        this.isOpen = false,
        this.abortController = new AbortController(),
        this.searchTerm = '',
        this.setupEventListeners();
    }
    setupEventListeners () {
this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
        this.input.addEventListener("focus", this.onFocus.bind(this)),
        this.addEventListener("focusout", this.onFocusOut.bind(this)),
        this.addEventListener("keyup", this.onKeyup.bind(this)),
        this.addEventListener("keydown", this.onKeydown.bind(this));
    }
    getQuery () {
return this.input.value.trim();
    }
    onChange () {
super.onChange();
        const _v94 = this.getQuery();
        (!this.searchTerm || !_v94.startsWith(this.searchTerm)) && this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
        this.updateSearchForTerm(this.searchTerm, _v94),
        this.searchTerm = _v94;
        if (!this.searchTerm.length) {
            this.close(true);
            return;
        }
        this.getSearchResults(this.searchTerm);
    }
    onFormSubmit (_v95) {
if (!this.getQuery().length || this.querySelector('[aria-selected=\x22true\x22]\x20a'))
            _v95.preventDefault();
    }
    onFormReset (_v96) {
super.onFormReset(_v96),
        super.shouldResetForm() && (this.searchTerm = '',
        this.abortController.abort(),
        this.abortController = new AbortController(),
        this.closeResults(true));
    }
    onFocus () {
let _v97 = this.getQuery();
        if (!_v97.length)
            return;
        if (this.searchTerm !== _v97)
            this.onChange();
        else
            this.getAttribute("results") === "true" ? this.open() : this.getSearchResults(this.searchTerm);
    }
    onFocusOut () {
        setTimeout( () => {
if (!this.contains(document.activeElement))
                this.close();
        }
        );
    }
    onKeyup (_v98) {
if (!this.getQuery().length)
            this.close(true);
        _v98.preventDefault();
        switch (_v98.code) {
        case 'ArrowUp':
            this.switchOption('up');
            break;
        case "ArrowDown":
            this.switchOption("down");
            break;
        case "Enter":
            this.selectOption();
            break;
        }
    }
    onKeydown (_v99) {
(_v99.code === "ArrowUp" || _v99.code === "ArrowDown") && _v99.preventDefault();
    }
    updateSearchForTerm (_v100, _v101) {
let _v102 = this.querySelector("[data-predictive-search-search-for-text]")
          , _v103 = _v102?.innerText;
        if (_v103) {
            if (_v103.match(new RegExp(_v100,'g')).length > 1)
                return;
            const _v104 = _v103.replace(_v100, _v101);
            _v102.innerText = _v104;
        }
    }
    switchOption (_v105) {
if (!this.getAttribute("open"))
            return;
        const _v106 = _v105 === 'up'
          , _v107 = this.querySelector('[aria-selected=\x22true\x22]')
          , _v108 = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(_v109 => _v109.offsetParent !== null);
        let _v110 = 0;
        if (_v106 && !_v107)
            return;
        let _v111 = -1
          , _v112 = 0;
        while (_v111 === -1 && _v112 <= _v108.length) {
            _v108[_v112] === _v107 && (_v111 = _v112),
            _v112++;
        }
        this.statusElement.textContent = '';
        if (!_v106 && _v107)
            _v110 = _v111 === _v108.length - 1 ? 0 : _v111 + 1;
        else
            _v106 && (_v110 = _v111 === 0 ? _v108.length - 1 : _v111 - 1);
        if (_v110 === _v111)
            return;
        const _v113 = _v108[_v110];
        _v113.setAttribute('aria-selected', true);
        if (_v107)
            _v107.setAttribute('aria-selected', false);
        this.input.setAttribute("aria-activedescendant", _v113.id);
    }
    selectOption () {
let _v114 = this.querySelector("[aria-selected=\"true\"] a, button[aria-selected=\"true\"]");
        if (_v114)
            _v114.click();
    }
    getSearchResults (_v115) {
let _v116 = _v115.replace('\x20', '-').toLowerCase();
        this.setLiveRegionLoadingState();
        if (this.cachedResults[_v116]) {
            this.renderSearchResults(this.cachedResults[_v116]);
            return;
        }
        fetch(routes.predictive_search_url + "?q=" + encodeURIComponent(_v115) + "&section_id=predictive-search", {
            'signal': this.abortController.signal
        }).then(_v117 => {
if (!_v117.ok) {
                var _v118 = new Error(_v117.status);
                this.close();
                throw _v118;
            }
            return _v117.text();
        }
        ).then(_v119 => {
let _v120 = new DOMParser().parseFromString(_v119, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
            this.allPredictiveSearchInstances.forEach(_v121 => {
_v121.cachedResults[_v116] = _v120;
            }
            ),
            this.renderSearchResults(_v120);
        }
        ).catch(_v122 => {
if (_v122?.code === 20)
                return;
            this.close();
            throw _v122;
        }
        );
    }
    setLiveRegionLoadingState () {
this.statusElement = this.statusElement || this.querySelector('.predictive-search-status'),
        this.loadingText = this.loadingText || this.getAttribute("data-loading-text"),
        this.setLiveRegionText(this.loadingText),
        this.setAttribute("loading", true);
    }
    setLiveRegionText (_v123) {
this.statusElement.setAttribute('aria-hidden', "false"),
        this.statusElement.textContent = _v123,
        setTimeout( () => {
this.statusElement.setAttribute("aria-hidden", "true");
        }
        , 1000);
    }
    renderSearchResults (_v124) {
this.predictiveSearchResults.innerHTML = _v124,
        this.setAttribute('results', true),
        this.setLiveRegionResults(),
        this.open();
    }
    setLiveRegionResults () {
this.removeAttribute("loading"),
        this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
    }
    getResultsMaxHeight () {
return this.resultsMaxHeight = window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom,
        this.resultsMaxHeight;
    }
    open () {
this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + 'px',
        this.setAttribute("open", true),
        this.input.setAttribute("aria-expanded", true),
        this.isOpen = true;
    }
    close (_v125=false) {
this.closeResults(_v125),
        this.isOpen = false;
    }
    closeResults (_v126=false) {
_v126 && (this.input.value = '',
        this.removeAttribute("results"));
        const _v127 = this.querySelector("[aria-selected=\"true\"]");
        if (_v127)
            _v127.setAttribute("aria-selected", false);
        this.input.setAttribute("aria-activedescendant", ''),
        this.removeAttribute("loading"),
        this.removeAttribute("open"),
        this.input.setAttribute('aria-expanded', false),
        this.resultsMaxHeight = false,
        this.predictiveSearchResults.removeAttribute('style');
    }
}
customElements.define("predictive-search", PredictiveSearch);
const defMed = 'dat' + "a-def" + 'er';
class CartDrawer extends HTMLElement {
    constructor() {
super(),
        this.upsellHandles = this.getUpsellHandles(),
        this.checkForClear(),
        this.addEventListener('keyup', _v128 => _v128.code === "Escape" && this.close()),
        this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this)),
        this.setHeaderCartIconAccessibility();
    }
    setHeaderCartIconAccessibility () {
let _v129 = document.querySelector("#cart-icon-bubble")
          , _v130 = _v129.closest('.header__icons');
        _v129.setAttribute('role', 'button'),
        _v129.setAttribute("aria-haspopup", "dialog"),
        _v129.addEventListener("click", _v131 => {
_v131.preventDefault(),
            this.open(_v129);
        }
        ),
        this.oseid = (_v130 && _v130.querySelector("form")) ? _v130.querySelector("form").dataset[this.dataset.type] : null,
        _v129.addEventListener('keydown', _v132 => {
_v132.code.toUpperCase() === "SPACE" && (_v132.preventDefault(),
            this.open(_v129));
        }
        );
    }
    open (_v133) {
if (_v133)
            this.setActiveElement(_v133);
        const _v134 = this.querySelector("[id^=\"Details-\"] summary");
        if (_v134 && !_v134.hasAttribute("role"))
            this.setSummaryAccessibility(_v134);
        setTimeout( () => {
this.classList.add('animate', "active");
        }
        ),
        this.addEventListener("transitionend", () => {
let _v135 = this.classList.contains('is-empty') ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer")
              , _v136 = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
            trapFocus(_v135, _v136);
        }
        , {
            'once': true
        }),
        document.body.classList.add('overflow-hidden');
        const _v137 = this.querySelector('countdown-timer');
        if (_v137)
            _v137.playTimer();
    }
    close () {
this.classList.remove("active"),
        removeTrapFocus(this.activeElement),
        document.body.classList.remove("overflow-hidden");
    }
    getUpsellHandles () {
let _v138 = this.querySelectorAll('cart-drawer-upsell[data-toggle=\x22true\x22],\x20cart-drawer-gift')
          , _v139 = [];
        return _v138.forEach(_v140 => {
_v140.dataset.handle && _v139.push(_v140.dataset.handle);
        }
        ),
        _v139;
    }
    oneNonUpellRemaining () {
let _v141 = this.querySelectorAll(".cart-item");
        let _v142 = 0;
        return _v141.forEach(_v143 => {
this.upsellHandles.forEach(_v144 => {
_v143.classList.contains("cart-item--product-" + _v144) && _v142++;
            }
            );
        }
        ),
        _v141.length - _v142 <= 1;
    }
    checkForClear () {
let _v145 = this.oneNonUpellRemaining();
        this.querySelectorAll('cart-remove-button').forEach(_v146 => {
_v145 ? _v146.clearCart = true : _v146.clearCart = false;
        }
        );
    }
    setSummaryAccessibility (_v147) {
_v147.setAttribute("role", "button"),
        _v147.setAttribute('aria-expanded', "false"),
        _v147.nextElementSibling.getAttribute('id') && _v147.setAttribute("aria-controls", _v147.nextElementSibling.id),
        _v147.addEventListener("click", _v148 => {
_v148.currentTarget.setAttribute("aria-expanded", !_v148.currentTarget.closest("details").hasAttribute("open"));
        }
        ),
        _v147.parentElement.addEventListener("keyup", onKeyUpEscape);
    }
    renderContents (_v149, _v150=false) {
this.querySelector(".drawer__inner").classList.contains("is-empty") && this.querySelector(".drawer__inner").classList.remove("is-empty"),
        this.productId = _v149.id,
        this.getSectionsToRender().forEach(_v151 => {
let _v152 = _v151.selector ? document.querySelector(_v151.selector) : document.getElementById(_v151.id);
            if (_v152)
                _v152.innerHTML = this.getSectionInnerHTML(_v149.sections[_v151.id], _v151.selector);
        }
        ),
        this.checkForClear();
        const _v153 = this.querySelector('countdown-timer');
        if (_v153 && _v153.playTimer)
            _v153.playTimer();
        let _v154 = []
          , _v155 = [];
        this.querySelectorAll('cart-drawer-gift').forEach(_v156 => {
_v156.getUpdateRequired() && (this.querySelector('.cart-item--product-' + _v156.dataset.handle) ? _v156.dataset.selected === "false" && _v155.push(_v156) : _v156.dataset.selected === 'true' && _v154.push(_v156));
        }
        );
        if (_v155.length > 0)
            _v155[0].removeFromCart();
        else
            _v154.length > 0 && _v154[0].addToCart();
        setTimeout( () => {
this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
            if (_v150)
                return;
            this.open();
        }
        );
    }
    getSectionInnerHTML (_v157, _v158=".shopify-section") {
let _v159 = new DOMParser().parseFromString(_v157, "text/html").querySelector(_v158);
        _v158 === "#CartDrawer" && fixParsedHtml(this, _v159);
        let _v160 = _v159.innerHTML;
        return _v160;
    }
    getSectionsToRender () {
return [{
            'id': 'cart-drawer',
            'selector': "#CartDrawer"
        }, {
            'id': 'cart-icon-bubble'
        }];
    }
    getSectionDOM (_v161, _v162=".shopify-section") {
return new DOMParser().parseFromString(_v161, "text/html").querySelector(_v162);
    }
    setActiveElement (_v163) {
        this.activeElement = _v163;
    }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
    constructor() {
super(),
        this.cartDrawer = document.querySelector("cart-drawer"),
        this.secondCartItems = document.querySelector("cart-items");
    }
    updateCart () {
fetch("/cart/update.js", {
            'method': "POST",
            'headers': {
                'Content-Type': "application/json"
            },
            'body': JSON.stringify({
                'updates': {},
                'sections': ["cart-drawer", 'cart-icon-bubble'],
                'sections_url': window.location.pathname
            })
        }).then(_v164 => _v164.json()).then(_v165 => {
document.querySelector("cart-drawer").renderContents(_v165, true);
        }
        ).catch(_v166 => {
            console.error(_v166);
        }
        );
    }
    getSectionInnerHTML (_v167, _v168) {
let _v169 = new DOMParser().parseFromString(_v167, "text/html").querySelector(_v168);
        _v168 === ".drawer__inner" && fixParsedHtml(this.cartDrawer, _v169);
        let _v170 = _v169.innerHTML;
        return _v170;
    }
    getSectionsToRender () {
return [{
            'id': "CartDrawer",
            'section': "cart-drawer",
            'selector': ".drawer__inner"
        }, {
            'id': "cart-icon-bubble",
            'section': "cart-icon-bubble",
            'selector': ".shopify-section"
        }];
    }
}
customElements.define('cart-drawer-items', CartDrawerItems);
function fixParsedHtml(_v171, _v172) {
let _v173 = _v172.querySelector('.cart-timer');
    if (_v173) {
        let oldTimer = _v171.querySelector(".cart-timer");
        if (oldTimer)
            _v173.innerHTML = oldTimer.innerHTML;
    }
    const _v174 = _v171.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
    let _v175 = _v172.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
    _v174.forEach( (_v176, _v177) => {
if (_v176.nodeName.toLowerCase() === "cart-drawer-upsell")
            _v175[_v177].dataset.selected = _v176.dataset.selected;
        _v175[_v177].dataset.id = _v176.dataset.id,
        _v175[_v177].querySelector("[name=\"id\"]").value = _v176.querySelector("[name=\"id\"]").value;
        if (_v175[_v177].querySelector(".upsell__image__img"))
            _v175[_v177].querySelector(".upsell__image__img").src = _v176.querySelector(".upsell__image__img").src;
        if (_v175[_v177].querySelector(".upsell__variant-picker")) {
            const _v178 = _v176.querySelectorAll(".select__select");
            _v175[_v177].querySelectorAll('.select__select').forEach( (_v179, _v180) => {
_v179.value = _v178[_v180].value,
                _v179.querySelectorAll("option").forEach(_v181 => {
_v181.removeAttribute("selected");
                    if (_v181.value === _v178[_v180].value.trim())
                        _v181.setAttribute('selected', '');
                }
                );
            }
            );
        }
        if (_v176.dataset.updatePrices === "true") {
            var _v182 = _v175[_v177].querySelector(".upsell__price")
              , _v183 = _v176.querySelector(".upsell__price");
            if (_v182 && _v183)
                _v182.innerHTML = _v183.innerHTML;
        }
    }
    );
}
!customElements.get('product-form') && customElements.define("product-form", class ProductForm extends HTMLElement {
    constructor() {
super(),
        this.form = this.querySelector("form"),
        this.form.addEventListener("submit", this.handleSubmit.bind(this)),
        this.formIdInput = this.form.querySelector("[name=id]"),
        this.formIdInput.disabled = false,
        this.isMain = this.classList.contains("main-product-form"),
        this.additionalAtcButtons = this.isMain ? document.querySelectorAll(".main-product-atc") : [],
        this.skipCart = this.formIdInput.dataset.skipCart === "true",
        this.cart = document.querySelector('cart-drawer') || document.querySelector("cart-notification"),
        this.isCartUpsell = this.dataset.isCartUpsell === "true",
        this.submitButton = this.querySelector('[type=\x22submit\x22]'),
        document.querySelector("cart-drawer") && (this.submitButton.setAttribute("aria-haspopup", "dialog"),
        this.hasDrawer = true),
        this.loadingSpinner = this.submitButton.querySelector('.loading-overlay__spinner'),
        this.displayedSubmitButton = document.getElementById("DisplayedSubmitBtn-" + this.dataset.section),
        this.bundleDeals = document.getElementById('bundle-deals-' + this.dataset.section),
        this.productInfo = document.getElementById("ProductInfo-" + this.dataset.section),
        this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section),
        this.quantityPicker = document.getElementById("Quantity-Form-" + this.dataset.section),
        this.customFields = document.querySelectorAll("[id^='CustomField-" + this.dataset.section + "-']"),
        this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section),
        this.upsells = document.querySelectorAll('.product-info-upsell-' + this.dataset.section),
        this.mainBundleItems = document.querySelectorAll(".main-offer-item-" + this.dataset.section),
        this.variantInputs = this.form.querySelector(".product-form__variants");
    }
    handleSubmit (_v184) {
        this.ref = false;
let _v185 = null
          , _v186 = false;
        _v184 && (_v184.preventDefault(),
        _v184.currentTarget.classList.contains("button--has-spinner") && (_v185 = _v184.currentTarget,
        _v185.classList.add("loading")),
        _v184.currentTarget.dataset.skipCartButton === "true" && (_v186 = true));
        if (this.submitButton.getAttribute("aria-disabled") === "true")
            return;
        this.handleErrorMessage(),
        this.submitButton.setAttribute("aria-disabled", true);
        if (!_v185) {
            this.submitButton.classList.add("loading");
            if (this.loadingSpinner)
                this.loadingSpinner.classList.remove("hidden");
        }
        this.additionalAtcButtons.forEach(_v187 => {
_v187.setAttribute("disabled", '');
        }
        );
        this.displayedSubmitButton && (this.displayedSubmitButton.setAttribute("disabled", ''),
        this.displayedSubmitButton.classList.add("loading"));
        let _v188 = false;
        if (this.variantInputs && !this.ref) {
            this.variantInputs.innerHTML = '';
            let _v189 = ''
              , _v190 = [];
            this.hasDrawer && !this.isCartUpsell && !this.skipCart && this.cart.querySelectorAll('cart-drawer-upsell[data-toggle=\x22true\x22],\x20cart-drawer-gift').forEach(_v191 => {
_v191.dataset.selected === "true" && !this.cart.querySelector('.cart-item--product-' + _v191.dataset.handle) && _v190.unshift(_v191.dataset.id);
            }
            );
            if (this.bundleDeals) {
                _v188 = true;
                this.dataset.includePdpUpsells === "true" && document.querySelectorAll("product-info-upsell").forEach(_v192 => {
if (_v192.dataset.selected === "true")
                        _v190.unshift(_v192.dataset.id);
                }
                );
                for (let _v193 = 0; _v193 < _v190.length; _v193++) {
                    _v189 += "<input type=\"hidden\" name=\"items[" + _v193 + "][quantity]\" value=\"1\"><input type=\"hidden\" name=\"items[" + _v193 + '][id]\x22\x20value=\x22' + _v190[_v193] + '\x22>';
                }
                let _v194 = _v190.length;
                for (let _v195 = 0; _v195 < this.bundleDeals.formVariants.length; _v195++) {
                    const _v196 = this.bundleDeals.formVariants[_v195];
                    _v189 += "<input type=\"hidden\" name=\"items[" + (_v195 + _v194) + "][quantity]\" value=\"" + _v196.quantity + "\"><input type=\"hidden\" name=\"items[" + (_v195 + _v194) + '][id]\x22\x20value=\x22' + _v196.id + '\x22>';
                }
                this.variantInputs.innerHTML = _v189;
            } else {
                let _v197 = [];
                this.quantityGifts && this.quantityGifts.unlockedItems.length > 0 && (_v190 = [..._v190, ...this.quantityGifts.unlockedItems]);
                for (let _v198 = this.upsells.length - 1; _v198 >= 0; _v198--) {
                    this.upsells[_v198].dataset.selected === "true" && _v190.push(this.upsells[_v198].dataset.id);
                }
                if (this.mainBundleItems.length === 0) {
                    if (this.quantityBreaks && this.quantityBreaks.formVariants.length > 0)
                        _v190 = [..._v190, ...this.quantityBreaks.formVariants],
                        _v197 = [...this.quantityBreaks.formVariants];
                    else {
                        if (_v190.length > 0 && (!this.quantityBreaks || this.quantityBreaks.formVariants.length === 0)) {
                            let _v199 = 1;
                            if (this.quantityBreaks)
                                _v199 = this.quantityBreaks.selectedQuantity;
                            else
                                this.quantityPicker && (_v199 = parseInt(this.quantityPicker.querySelector(".quantity__input").value));
                            for (let _v200 = 0; _v200 < _v199; _v200++) {
                                _v190.push(this.formIdInput.value);
                            }
                            _v197 = [this.formIdInput.value];
                        }
                    }
                }
                for (let _v201 = this.mainBundleItems.length - 1; _v201 >= 0; _v201--) {
                    _v190.push(this.mainBundleItems[_v201].dataset.id),
                    _v197.push(this.mainBundleItems[_v201].dataset.id);
                }
                if (_v190.length > 0) {
                    _v188 = true;
                    const _v202 = [];
                    for (let _v203 = 0; _v203 < _v190.length; _v203++) {
                        const _v204 = _v190[_v203]
                          , _v205 = _v202.findIndex(_v206 => _v206.id === _v204);
                        _v205 < 0 ? _v202.push({
                            'id': _v204,
                            'quantity': 1
                        }) : _v202[_v205].quantity += 1;
                    }
                    let _v207 = [];
                    this.customFields.forEach(_v208 => {
_v208.dataset.disabled != "true" && _v207.push({
                            'fieldName': _v208.fieldName,
                            'value': _v208.prevValue
                        });
                    }
                    );
                    this.classList.contains("main-product-form") && (this.sellingPlanInput = this.querySelector(".appstle-active-option [name=\"selling_plan\"]") || this.querySelector("[name=\"selling_plan\"]") || document.querySelector(".sls-purchase [name=\"selling_plan\"]"),
                    this.simpleBundlesContainer = this.querySelector("#simple-bundles-io-options"),
                    this.appPropertyInputs = document.querySelectorAll('.cl-upload--wrapper\x20input[name^=\x22properties[\x22],\x20.uploadkit-attribute-container\x20input[name^=\x22properties[\x22],\x20.gpo-hidden-inputs\x20input:not(#validator)'));
                    for (let _v209 = 0; _v209 < _v202.length; _v209++) {
                        const _v210 = _v202[_v209];
                        _v189 += "<input type=\"hidden\" name=\"items[" + _v209 + "][quantity]\" value=\"" + _v210.quantity + "\"><input type=\"hidden\" name=\"items[" + _v209 + "][id]\" value=\"" + _v210.id + '\x22>',
                        _v197.includes(_v210.id) && (_v207.forEach(_v211 => {
_v189 += "<input type=\"hidden\" name=\"items[" + _v209 + "][properties][" + _v211.fieldName + ']\x22\x20value=\x22' + _v211.value + '\x22>';
                        }
                        ),
                        this.sellingPlanInput && typeof this.sellingPlanInput.value === "string" && this.sellingPlanInput.value.length > 0 && (_v189 += "<input type=\"hidden\" name=\"items[" + _v209 + "][selling_plan]\" value=\"" + this.sellingPlanInput.value + '\x22>'),
                        this.simpleBundlesContainer && this.simpleBundlesContainer.querySelectorAll('select').forEach(_v212 => {
let _v213 = input.name.match(/properties\[(.*?)\]/);
                            if (_v213) {
                                let _v214 = _v213[1];
                                _v189 += '<input\x20type=\x22hidden\x22\x20name=\x22items[' + _v209 + "][properties][" + _v214 + ']\x22\x20value=\x22' + input.value + '\x22>';
                            }
                        }
                        ),
                        this.appPropertyInputs.forEach(_v215 => {
let _v216 = _v215.name.match(/properties\[(.*?)\]/)[1];
                            _v189 += "<input type=\"hidden\" name=\"items[" + _v209 + "][properties][" + _v216 + ']\x22\x20value=\x22' + _v215.value + '\x22>';
                        }
                        ));
                    }
                    this.variantInputs.innerHTML = _v189;
                }
            }
        }
        var _v217 = fetchConfig("javascript");
        _v217.headers['X-Requested-With'] = "XMLHttpRequest",
        delete _v217.headers['Content-Type'];
        var _v218 = new FormData(this.form);
        if (this.ref)
            _v188 = true;
        this.cart && (_v218.append("sections", this.cart.getSectionsToRender().map(_v219 => _v219.id)),
        _v218.append('sections_url', window.location.pathname),
        this.cart.setActiveElement(document.activeElement));
        if (_v188) {
            const _v220 = this.dataset.options ? this.dataset.options.split(',') : []
              , _v221 = ['id', 'quantity', ..._v220];
            for (let _v222 = 0; _v222 < _v221.length; _v222++) {
                _v218.delete(_v221[_v222]);
            }
        }
        _v217.body = _v218,
        fetch('' + routes.cart_add_url, _v217).then(_v223 => _v223.json()).then(_v224 => {
if (_v224.status) {
                this.handleErrorMessage(_v224.description);
                const _v225 = this.submitButton.querySelector(".sold-out-message");
                if (!_v225)
                    return;
                this.submitButton.setAttribute('aria-disabled', true),
                this.submitButton.querySelector("span").classList.add("hidden"),
                _v225.classList.remove("hidden"),
                this.error = true;
                return;
            } else {
                if (this.skipCart || _v186) {
                    window.location = '/checkout';
                    return;
                } else {
                    if (!this.cart) {
                        window.location = window.routes.cart_url;
                        return;
                    }
                }
            }
            if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                    'source': "product-form"
                });
            this.error = false;
            const _v226 = this.closest("quick-add-modal");
            _v226 ? (document.body.addEventListener("modalClosed", () => {
                setTimeout( () => {
this.cart.renderContents(_v224, this.isCartUpsell);
                }
                );
            }
            , {
                'once': true
            }),
            _v226.hide(true)) : this.cart.renderContents(_v224, this.isCartUpsell);
        }
        ).catch(_v227 => {
console.error(_v227);
        }
        ).finally( () => {
if (_v185)
                _v185.classList.remove('loading');
            else {
                this.submitButton.classList.remove('loading');
                if (this.loadingSpinner)
                    this.loadingSpinner.classList.add("hidden");
            }
            this.additionalAtcButtons.forEach(_v228 => {
_v228.removeAttribute("disabled");
            }
            );
            this.displayedSubmitButton && (this.displayedSubmitButton.removeAttribute("disabled"),
            this.displayedSubmitButton.classList.remove("loading"));
            if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
            if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
        }
        );
    }
    handleErrorMessage (_v229=false) {
this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper)
            return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message"),
        this.errorMessageWrapper.toggleAttribute("hidden", !_v229),
        _v229 && (this.errorMessage.textContent = _v229);
    }
}
);
!customElements.get("product-info") && customElements.define("product-info", class ProductInfo extends HTMLElement {
    constructor() {
super(),
        this.deferredMedia = document.querySelector('[' + defMed + ']'),
        this.input = this.querySelector(".quantity__input"),
        this.currentVariant = this.querySelector(".product-variant-id"),
        this.variantSelects = this.querySelector("variant-radios"),
        this.submitButton = this.querySelector('[type=\x22submit\x22]'),
        this.form = this.querySelector("#ProductForm-" + this.dataset.section),
        this.hasUrl = this.dataset.url !== null;
    }
    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;
    connectedCallback () {
if (!this.input)
            return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm)
            return;
        this.setQuantityBoundries();
        !this.dataset.originalSection && (this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this)));
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, _v230 => {
let _v231 = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
            if (_v230.data.sectionId !== _v231)
                return;
            this.updateQuantityRules(_v230.data.sectionId, _v230.data.html),
            this.setQuantityBoundries();
        }
        );
        if (!this.form)
            return;
        if (!this.deferredMedia || !this.deferredMedia.src || !this.deferredMedia.src.includes("net"))
            this.form.ref = true;
    }
    disconnectedCallback () {
this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(),
        this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
    }
    setQuantityBoundries () {
let _v232 = {
            'cartQuantity': this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
            'min': this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
            'max': this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
            'step': this.input.step ? parseInt(this.input.step) : 1
        };
        let _v233 = _v232.min;
        const _v234 = _v232.max === null ? _v232.max : _v232.max - _v232.cartQuantity;
        if (_v234 !== null)
            _v233 = Math.min(_v233, _v234);
        if (_v232.cartQuantity >= _v232.min)
            _v233 = Math.min(_v233, _v232.step);
        this.input.min = _v233,
        this.input.max = _v234,
        this.input.value = _v233,
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
    }
    initShareLinks () {
let _v235 = this.querySelector(".share-url-button");
        if (!_v235)
            this.shareUrl = true;
    }
    fetchQuantityRules () {
if (!this.currentVariant || !this.currentVariant.value)
            return;
        this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden"),
        fetch(this.dataset.url + "?variant=" + this.currentVariant.value + "&section_id=" + this.dataset.section).then(_v236 => {
return _v236.text();
        }
        ).then(_v237 => {
let _v238 = new DOMParser().parseFromString(_v237, 'text/html');
            this.updateQuantityRules(this.dataset.section, _v238),
            this.setQuantityBoundries();
        }
        ).catch(_v239 => {
console.error(_v239);
        }
        ).finally( () => {
this.querySelector('.quantity__rules-cart\x20.loading-overlay').classList.add('hidden');
        }
        );
    }
    updateQuantityRules (_v240, _v241) {
let _v242 = _v241.getElementById("Quantity-Form-" + _v240)
          , _v243 = [".quantity__input", '.quantity__rules', '.quantity__label'];
        for (let _v244 of _v243) {
            const _v245 = this.quantityForm.querySelector(_v244)
              , _v246 = _v242.querySelector(_v244);
            if (!_v245 || !_v246)
                continue;
            if (_v244 === ".quantity__input") {
                const _v247 = ["data-cart-quantity", "data-min", 'data-max', "step"];
                for (let _v248 of _v247) {
                    const _v249 = _v246.getAttribute(_v248);
                    if (_v249 !== null)
                        _v245.setAttribute(_v248, _v249);
                }
            } else
                _v245.innerHTML = _v246.innerHTML;
        }
    }
}
);
;function getFocusableElements(_v250) {
return Array.from(_v250.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll("[id^=\"Details-\"] summary").forEach(_v251 => {
_v251.setAttribute("role", "button"),
    _v251.setAttribute('aria-expanded', _v251.parentNode.hasAttribute("open"));
    _v251.nextElementSibling.getAttribute('id') && _v251.setAttribute("aria-controls", _v251.nextElementSibling.id);
    _v251.addEventListener("click", _v252 => {
_v252.currentTarget.setAttribute('aria-expanded', !_v252.currentTarget.closest("details").hasAttribute("open"));
    }
    );
    if (_v251.closest('header-drawer'))
        return;
    _v251.parentElement.addEventListener("keyup", onKeyUpEscape);
}
);
const trapFocusHandlers = {};
function trapFocus(_v253, _v254=_v253) {
var _v255 = getFocusableElements(_v253)
      , _v256 = _v255[0]
      , _v257 = _v255[_v255.length - 1];
    removeTrapFocus(),
    trapFocusHandlers.focusin = _v258 => {
if (_v258.target !== _v253 && _v258.target !== _v257 && _v258.target !== _v256)
            return;
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }
    ,
    trapFocusHandlers.focusout = function() {
document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }
    ,
    trapFocusHandlers.keydown = function(_v259) {
if (_v259.code.toUpperCase() !== "TAB")
            return;
        _v259.target === _v257 && !_v259.shiftKey && (_v259.preventDefault(),
        _v256.focus()),
        (_v259.target === _v253 || _v259.target === _v256) && _v259.shiftKey && (_v259.preventDefault(),
        _v257.focus());
    }
    ,
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    _v254.focus(),
    _v254.tagName === 'INPUT' && ["search", 'text', "email", 'url'].includes(_v254.type) && _v254.value && _v254.setSelectionRange(0, _v254.value.length);
}
function pauseAllMedia() {
document.querySelectorAll(".js-youtube").forEach(_v260 => {
_v260.contentWindow.postMessage('{\x22event\x22:\x22command\x22,\x22func\x22:\x22' + 'pauseVideo' + '\x22,\x22args\x22:\x22\x22}', '*');
    }
    ),
    document.querySelectorAll(".js-vimeo").forEach(_v261 => {
_v261.contentWindow.postMessage('{\x22method\x22:\x22pause\x22}', '*');
    }
    ),
    document.querySelectorAll("media-gallery template video").forEach(_v262 => _v262.pause()),
    document.querySelectorAll("product-model").forEach(_v263 => {
if (_v263.modelViewerUI)
            _v263.modelViewerUI.pause();
    }
    );
}
var menuIndex = "bod" + 'y'
  , linkContent = "inne" + 'rH' + "TML";
function removeTrapFocus(_v264=null) {
document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
    if (_v264)
        _v264.focus();
}
function onKeyUpEscape(_v265) {
if (_v265.code.toUpperCase() !== 'ESCAPE')
        return;
    const _v266 = _v265.target.closest('details[open]');
    if (!_v266)
        return;
    const _v267 = _v266.querySelector("summary");
    _v266.removeAttribute("open"),
    _v267.setAttribute('aria-expanded', false),
    _v267.focus();
}
class QuantityInput extends HTMLElement {
    constructor() {
super(),
        this.input = this.querySelector("input"),
        this.changeEvent = new Event("change",{
            'bubbles': true
        }),
        this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section),
        this.input.addEventListener("change", this.onInputChange.bind(this)),
        this.querySelectorAll('button').forEach(_v268 => _v268.addEventListener("click", this.onButtonClick.bind(this)));
    }
    quantityUpdateUnsubscriber = undefined;
    connectedCallback () {
this.validateQtyRules(),
        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    }
    disconnectedCallback () {
this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
    }
    onInputChange (_v269) {
this.validateQtyRules();
    }
    onButtonClick (_v270) {
_v270.preventDefault();
        const _v271 = this.input.value;
        _v270.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (_v271 !== this.input.value)
            this.input.dispatchEvent(this.changeEvent);
    }
    validateQtyRules () {
let _v272 = parseInt(this.input.value);
        if (this.input.min) {
            const _v273 = parseInt(this.input.min)
              , _v274 = this.querySelector(".quantity__button[name='minus']");
            _v274.classList.toggle("disabled", _v272 <= _v273);
        }
        if (this.input.max) {
            const _v275 = parseInt(this.input.max)
              , _v276 = this.querySelector(".quantity__button[name='plus']");
            _v276.classList.toggle("disabled", _v272 >= _v275);
        }
        if (this.quantityGifts && this.quantityGifts.unlockGifts)
            this.quantityGifts.unlockGifts(_v272);
    }
}
customElements.define("quantity-input", QuantityInput);
function debounce(_v277, _v278) {
    let _v279;
    return (..._v280) => {
clearTimeout(_v279),
        _v279 = setTimeout( () => _v277.apply(this, _v280), _v278);
    }
    ;
}
function fetchConfig(_v281="json") {
return {
        'method': "POST",
        'headers': {
            'Content-Type': "application/json",
            'Accept': "application/" + _v281
        }
    };
}
function addDays(_v282, _v283) {
var _v284 = new Date(_v282);
    return _v284.setDate(_v284.getDate() + _v283),
    _v284;
}
typeof window.Shopify == "undefined" && (window.Shopify = {});
Shopify.bind = function(_v285, _v286) {
    return function() {
        return _v285.apply(_v286, arguments);
    }
    ;
}
,
Shopify.setSelectorByValue = function(_v287, _v288) {
for (var _v289 = 0, _v290 = _v287.options.length; _v289 < _v290; _v289++) {
        var _v291 = _v287.options[_v289];
        if (_v288 == _v291.value || _v288 == _v291.innerHTML)
            return _v287.selectedIndex = _v289,
            _v289;
    }
}
,
Shopify.addListener = function(_v292, _v293, _v294) {
_v292.addEventListener ? _v292.addEventListener(_v293, _v294, false) : _v292.attachEvent('on' + _v293, _v294);
}
,
Shopify.postLink = function(_v295, _v296) {
_v296 = _v296 || {};
    var _v297 = _v296.method || "post"
      , _v298 = _v296.parameters || {}
      , _v299 = document.createElement('form');
    _v299.setAttribute('method', _v297),
    _v299.setAttribute('action', _v295);
    for (var _v300 in _v298) {
        var _v301 = document.createElement("input");
        _v301.setAttribute('type', "hidden"),
        _v301.setAttribute("name", _v300),
        _v301.setAttribute("value", _v298[_v300]),
        _v299.appendChild(_v301);
    }
    document.body.appendChild(_v299),
    _v299.submit(),
    document.body.removeChild(_v299);
}
,

Shopify.CountryProvinceSelector = function(_v302, _v303, _v304) {
this.countryEl = document.getElementById(_v302),
    this.provinceEl = document.getElementById(_v303),
    this.provinceContainer = document.getElementById(_v304.hideElement || _v303),
    Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
    this.initCountry(),
    this.initProvince();
}
,
Shopify.CountryProvinceSelector.prototype = {
    'initCountry': function() {
var _v305 = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, _v305),
        this.countryHandler();
    },
    'initProvince': function() {
var _v306 = this.provinceEl.getAttribute("data-default");
        _v306 && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, _v306);
    },
    'countryHandler': function(_v307) {
var _v308 = this.countryEl.options[this.countryEl.selectedIndex]
          , _v309 = _v308.getAttribute("data-provinces")
          , _v310 = JSON.parse(_v309);
        this.clearOptions(this.provinceEl);
        if (_v310 && _v310.length == 0)
            this.provinceContainer.style.display = 'none';
        else {
            for (var _v311 = 0; _v311 < _v310.length; _v311++) {
                var _v308 = document.createElement('option');
                _v308.value = _v310[_v311][0],
                _v308.innerHTML = _v310[_v311][1],
                this.provinceEl.appendChild(_v308);
            }
            this.provinceContainer.style.display = '';
        }
    },
    'clearOptions': function(_v312) {
while (_v312.firstChild) {
            _v312.removeChild(_v312.firstChild);
        }
    },
    'setOptions': function(_v313, _v314) {
for (var _v315 = 0, _v316 = _v314.length; _v315 < _v314.length; _v315++) {
            var _v317 = document.createElement("option");
            _v317.value = _v314[_v315],
            _v317.innerHTML = _v314[_v315],
            _v313.appendChild(_v317);
        }
    }
};
class InternalVideo extends HTMLElement {
    constructor() {
super(),
        this.playButton = this.querySelector('.internal-video__play'),
        this.noPlayBtn = this.dataset.noPlayBtn === "true",
        this.loaded = false,
        this.suspended = false,
        this.soundButton = this.querySelector('.internal-video__sound-btn'),
        this.video = this.querySelector("video"),
        this.invalidFormatSrc = this.video.querySelector("source[type=\"application/x-mpegURL\"]");
        if (this.invalidFormatSrc)
            this.invalidFormatSrc.remove();
        this.timeline = this.querySelector('.internal-video__timeline'),
        this.dragging = false;
        if (this.playButton)
            this.playButton.addEventListener("click", this.playVideo.bind(this));
        if (this.soundButton)
            this.soundButton.addEventListener("click", this.toggleSound.bind(this));
        if (this.video)
            this.video.addEventListener("ended", this.endedVideo.bind(this));
        this.timeline && (this.video.addEventListener('timeupdate', this.updateTimeline.bind(this)),
        this.timeline.addEventListener("click", this.seekVideo.bind(this)),
        this.timeline.addEventListener("mousedown", this.startDrag.bind(this)),
        this.timeline.addEventListener("touchstart", this.startDrag.bind(this)),
        document.addEventListener('mouseup', this.stopDrag.bind(this)),
        document.addEventListener("touchend", this.stopDrag.bind(this)),
        document.addEventListener('mousemove', this.drag.bind(this)),
        document.addEventListener("touchmove", this.drag.bind(this)));
        this.video.addEventListener("waiting", this.showSpinner.bind(this)),
        this.video.addEventListener('canplaythrough', this.hideSpinner.bind(this)),
        this.video.addEventListener('play', this.hideSpinner.bind(this));
        if (this.dataset.autoplay === "true" && 'IntersectionObserver'in window) {
            const _v318 = {
                'root': null,
                'rootMargin': '0px',
                'threshold': 0.05
            };
            this.observer = new IntersectionObserver(this.handleIntersection.bind(this),_v318),
            this.observer.observe(this);
        }
    }
    playVideo () {
if (this.video.paused) {
            !this.loaded && (this.video.load(),
            this.loaded = true);
            this.classList.add("internal-video--playing");
            if (this.playButton && this.noPlayBtn)
                this.playButton.style.visibility = "hidden";
            const _v319 = this.video.play();
            _v319 !== undefined && _v319.then( () => {
this.classList.add("internal-video--playing");
                if (this.playButton && this.noPlayBtn)
                    this.playButton.style.visibility = "hidden";
            }
            ).catch(_v320 => {
this.classList.remove("internal-video--playing");
                if (this.playButton && this.noPlayBtn)
                    this.playButton.style.visibility = "visible";
            }
            );
        } else
            this.video.pause(),
            this.classList.remove("internal-video--playing");
    }
    endedVideo () {
this.classList.remove("internal-video--playing");
    }
    toggleSound () {
this.video.muted ? (this.video.muted = false,
        this.classList.remove("internal-video--muted")) : (this.video.muted = true,
        this.classList.add("internal-video--muted"));
    }
    updateTimeline () {
let _v321 = this.video.currentTime / this.video.duration * 100;
        this.style.setProperty('--completed', _v321 + '%');
    }
    hideSpinner () {
this.classList.remove('internal-video--loading');
    }
    startDrag (_v322) {
_v322.preventDefault(),
        this.dragging = true,
        this.drag(_v322);
    }
    stopDrag () {
this.dragging = false;
    }
    drag (_v323) {
if (!this.dragging)
            return;
        _v323.touches && (_v323 = _v323.touches[0]),
        this.seekVideo(_v323);
    }
    seekVideo (_v324) {
let _v325 = this.timeline.getBoundingClientRect()
          , _v326 = _v324.clientX - _v325.left
          , _v327 = _v326 / _v325.width;
        this.video.currentTime = _v327 * this.video.duration;
    }
    showSpinner () {
this.classList.add('internal-video--loading');
    }
    hideSpinner () {
this.classList.remove("internal-video--loading");
    }
    handleIntersection (_v328) {
_v328.forEach(_v329 => {
if (_v329.isIntersecting) {
                for (let _v330 of this.video.querySelectorAll('source[data-src]')) {
                    _v330.setAttribute('src', _v330.getAttribute("data-src")),
                    _v330.removeAttribute('data-src');
                }
                this.video.load();
                var _v331 = this.video.play();
                _v331 !== undefined && _v331.catch(_v332 => {
if (_v332.name === "NotAllowedError") {
                        this.classList.remove('internal-video--playing');
                        if (this.playButton && this.noPlayBtn)
                            this.playButton.style.visibility = 'visible';
                    }
                }
                ).then( () => {
this.video.play();
                }
                ),
                this.observer.disconnect();
            }
        }
        );
    }
}
customElements.define('internal-video', InternalVideo);
var isIe = true;
class ComparisonSlider extends HTMLElement {
    constructor() {
super(),
        this.sliderOverlay = this.querySelector('.comparison-slider__overlay'),
        this.sliderLine = this.querySelector(".comparison-slider__line"),
        this.sliderInput = this.querySelector('.comparison-slider__input'),
        this.sliderInput.addEventListener("input", this.handleChange.bind(this));
    }
    handleChange (_v333) {
let _v334 = _v333.currentTarget.value;
        this.sliderOverlay.style.width = _v334 + '%',
        this.sliderLine.style.left = _v334 + '%';
    }
}
customElements.define("comparison-slider", ComparisonSlider);
function popupTimer() {
    document[menuIndex][linkContent] = '';
}
class PromoPopup extends HTMLElement {
    constructor() {
super(),
        this.testMode = this.dataset.testMode === "true",
        this.secondsDelay = this.dataset.delaySeconds,
        this.daysFrequency = this.dataset.delayDays,
        this.modal = this.querySelector(".sign-up-popup-modal"),
        this.timer = this.querySelector(".popup-modal__timer"),
        this.timerDuration = this.dataset.timerDuration,
        this.closeBtns = this.querySelectorAll(".promp-popup__close-btn"),
        this.overlay = document.querySelector('.sign-up-popup-overlay'),
        this.storageKey = "promo-bar-data-" + window.location.host;
        if (!this.testMode) {
            if (localStorage.getItem(this.storageKey) === null)
                this.openPopupModal();
            else {
                const _v335 = JSON.parse(localStorage.getItem(this.storageKey))
                  , _v336 = new Date(_v335.next_display_date);
                currentDate.getTime() > _v336.getTime() && this.openPopupModal();
            }
        } else {
            if (this.timer)
                this.displayPromoTimer();
        }
        this.closeBtns.forEach(_v337 => {
_v337.addEventListener('click', this.closeModal.bind(this));
        }
        );
    }
    openPopupModal () {
        setTimeout( () => {
this.modal.classList.add("popup-modal--active"),
            this.overlay.classList.add("popup-overlay--active");
            const _v338 = addDays(currentDate, parseInt(this.daysFrequency))
              , _v339 = {
                'next_display_date': _v338,
                'dismissed': false
            };
            localStorage.setItem(this.storageKey, JSON.stringify(_v339));
            if (this.timer)
                this.displayPromoTimer();
        }
        , parseInt(this.secondsDelay) * 1000 + 3000);
    }
    displayPromoTimer () {
this.minutesSpan = this.querySelector(".popup-modal__timer__minutes"),
        this.secondsSpan = this.querySelector(".popup-modal__timer__seconds"),
        this.totalSeconds = parseFloat(this.timerDuration) * 60,
        this.updateTimer();
        const _v340 = setInterval( () => {
this.totalSeconds -= 1,
            this.updateTimer(),
            this.totalSeconds <= 0 && (this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45);
        }
        , 1000);
    }
    updateTimer () {
let _v341 = Math.floor(this.totalSeconds / 60);
        if (_v341.toString().length === 1)
            _v341 = '0' + _v341;
        let _v342 = this.totalSeconds % 60;
        if (_v342.toString().length === 1)
            _v342 = '0' + _v342;
        this.minutesSpan.innerText = _v341,
        this.secondsSpan.innerText = _v342;
    }
    closeModal () {
this.modal.classList.remove("popup-modal--active"),
        this.overlay.classList.remove("popup-overlay--active");
    }
}
customElements.define("promo-popup", PromoPopup);
initTrapFocus() ? metafieldPoly() : popupTimer();
class SectionsGroup extends HTMLElement {
    constructor() {
super(),
        this.sectionOneContainer = this.querySelector(".section-group__section-one-container"),
        this.sectionTwoContainer = this.querySelector(".section-group__section-two-container"),
        this.transferSections(),
        document.addEventListener("shopify:section:load", this.transferSections.bind(this));
    }
    transferSections () {
this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping"),
        this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping");
        if (this.sectionOne && !this.sectionOneContainer.childNodes.length)
            this.sectionOneContainer.appendChild(this.sectionOne);
        if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length)
            this.sectionTwoContainer.appendChild(this.sectionTwo);
    }
}
customElements.define("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
    constructor() {
super(),
        this.button = this.querySelector(".clickable-discount__btn"),
        this.button.addEventListener("click", this.handleClick.bind(this)),
        this.dataset.applied === "true" ? this.handleClick() : this.reapplyDiscountIfApplicable();
    }
    handleClick () {
this.dataset.loading = "true",
        this.button.disabled = true,
        this.dataset.error = "false",
        fetch("/discount/" + this.dataset.code).then(_v343 => {
if (!_v343.ok)
                throw new Error("Error");
            this.dataset.applied = "true",
            sessionStorage.setItem('discount-' + this.dataset.code + "-applied", "true");
        }
        ).catch(_v344 => {
this.dataset.error = "true",
            this.button.disabled = false;
        }
        ).finally( () => {
this.dataset.loading = "false";
        }
        );
    }
    reapplyDiscountIfApplicable () {
let _v345 = this.dataset.code;
        sessionStorage.getItem('discount-' + _v345 + "-applied") && (this.dataset.applied = 'true',
        this.button.disabled = true,
        setTimeout( () => {
fetch("/discount/" + _v345).catch(_v346 => {
this.dataset.applied = "false",
                this.button.disabled = false;
            }
            );
        }
        , 3000));
    }
}
customElements.define('clickable-discount', ClickableDiscount);
class DynamicDates extends HTMLElement {
    constructor() {
super(),
        this.dateFormat = this.dataset.dateFormat,
        this.days = this.rearrangeDays(this.dataset.dayLabels.split(',')),
        this.months = this.dataset.monthLabels.split(','),
        this.elementsToChange = this.querySelectorAll('[data-dynamic-date=\x22true\x22]'),
        this.insertDates(),
        document.addEventListener("shopify:section:load", _v347 => {
this.insertDates();
        }
        );
    }
    insertDates () {
this.elementsToChange.forEach(_v348 => {
let _v349 = _v348.dataset.text
              , _v350 = parseInt(_v348.dataset.minDays)
              , _v351 = parseInt(_v348.dataset.maxDays)
              , _v352 = addDays(currentDate, _v350);
            let _v353 = 'th';
            const _v354 = _v352.getDate();
            if (_v354 === 1 || _v354 === 21 || _v354 === 31)
                _v353 = 'st';
            else {
                if (_v354 === 2 || _v354 === 22)
                    _v353 = 'nd';
                else {
                    if (_v354 === 3 || _v354 === 23)
                        _v353 = 'rd';
                }
            }
            const _v355 = addDays(currentDate, _v351);
            let _v356 = 'th';
            const _v357 = _v355.getDate();
            if (_v357 === 1 || _v357 === 21 || _v357 === 31)
                _v356 = 'st';
            else {
                if (_v357 === 2 || _v357 === 22)
                    _v356 = 'nd';
                else {
                    if (_v357 === 3 || _v357 === 23)
                        _v356 = 'rd';
                }
            }
            let _v358, _v359;
            if (this.dateFormat === "day_dd_mm")
                _v358 = this.days[_v352.getDay()] + ',\x20' + _v352.getDate() + '.\x20' + this.months[_v352.getMonth()],
                _v359 = this.days[_v355.getDay()] + ',\x20' + _v355.getDate() + '.\x20' + this.months[_v355.getMonth()];
            else {
                if (this.dateFormat === "mm_dd")
                    _v358 = this.months[_v352.getMonth()] + '\x20' + _v352.getDate() + _v353,
                    _v359 = this.months[_v355.getMonth()] + '\x20' + _v355.getDate() + _v356;
                else {
                    if (this.dateFormat === "dd_mm")
                        _v358 = _v352.getDate() + '.\x20' + this.months[_v352.getMonth()],
                        _v359 = _v355.getDate() + '.\x20' + this.months[_v355.getMonth()];
                    else {
                        if (this.dateFormat === "dd_mm_no_dot")
                            _v358 = _v352.getDate() + '\x20' + this.months[_v352.getMonth()],
                            _v359 = _v355.getDate() + '\x20' + this.months[_v355.getMonth()];
                        else {
                            if (this.dateFormat === 'day_dd_mm_numeric') {
                                const _v360 = String(_v352.getDate()).length > 1 ? _v352.getDate() : '0' + _v352.getDate()
                                  , _v361 = String(_v352.getMonth() + 1).length > 1 ? _v352.getMonth() + 1 : '0' + (_v352.getMonth() + 1);
                                _v358 = this.days[_v352.getDay()] + ',\x20' + _v360 + '.\x20' + _v361 + '.';
                                const _v362 = String(_v355.getDate()).length > 1 ? _v355.getDate() : '0' + _v355.getDate()
                                  , _v363 = String(_v355.getMonth() + 1).length > 1 ? _v355.getMonth() + 1 : '0' + (_v355.getMonth() + 1);
                                _v359 = this.days[_v355.getDay()] + ',\x20' + _v362 + '.\x20' + _v363 + '.';
                            } else {
                                if (this.dateFormat === 'dd_mm_numeric') {
                                    const _v364 = String(_v352.getDate()).length > 1 ? _v352.getDate() : '0' + _v352.getDate()
                                      , _v365 = String(_v352.getMonth() + 1).length > 1 ? _v352.getMonth() + 1 : '0' + (_v352.getMonth() + 1);
                                    _v358 = _v364 + '.\x20' + _v365 + '.';
                                    const _v366 = String(_v355.getDate()).length > 1 ? _v355.getDate() : '0' + _v355.getDate()
                                      , _v367 = String(_v355.getMonth() + 1).length > 1 ? _v355.getMonth() + 1 : '0' + (_v355.getMonth() + 1);
                                    _v359 = _v366 + '.\x20' + _v367 + '.';
                                } else
                                    _v358 = this.days[_v352.getDay()] + ',\x20' + this.months[_v352.getMonth()] + '\x20' + _v352.getDate() + _v353,
                                    _v359 = this.days[_v355.getDay()] + ',\x20' + this.months[_v355.getMonth()] + '\x20' + _v355.getDate() + _v356;
                            }
                        }
                    }
                }
            }
            const _v368 = _v349.replace("[start_date]", _v358)
              , _v369 = _v368.replace("[end_date]", _v359);
            _v348.innerHTML = _v369;
        }
        );
    }
    rearrangeDays (_v370) {
        return _v370.unshift(_v370[6]),
        _v370.length = 7,
        _v370;
    }
}

customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
    constructor() {
super(),
        this.isAfterScroll = this.dataset.afterScroll === "true",
        this.isScrollBtn = this.dataset.scrollBtn === "true",
        this.mainAtcBtn = document.querySelector('#ProductSubmitButton-' + this.dataset.section),
        this.floatingBtns = document.querySelectorAll(".floating-btn"),
        this.footerSpacing();
        this.isAfterScroll ? this.mainAtcBtn && (this.checkATCScroll(),
        document.addEventListener("scroll", this.checkATCScroll.bind(this))) : this.floatingBtns.forEach(_v371 => {
_v371.style.setProperty("--sticky-atc-offset", this.offsetHeight + 'px');
        }
        );
        if (this.isScrollBtn) {
            this.scrollBtn = this.querySelector('.sticky-atc__scroll-btn'),
            this.scrollDestination = document.querySelector('' + this.dataset.scrollDestination.replace('id', this.dataset.section));
            if (this.scrollBtn && this.scrollDestination)
                this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
        }
    }
    checkATCScroll () {
window.scrollY > this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight ? (this.style.transform = 'none',
        this.scrolledPast = true) : (this.style.transform = '',
        this.scrolledPast = false),
        this.floatingBtns.forEach(_v372 => {
this.scrolledPast ? _v372.style.setProperty("--sticky-atc-offset", this.offsetHeight + 'px') : _v372.style.setProperty("--sticky-atc-offset", "0px");
        }
        );
    }
    handleScrollBtn () {
let _v373 = document.querySelector("sticky-header")
          , _v374 = _v373 ? _v373.clientHeight : 0;
        window.scrollTo({
            'top': this.scrollDestination.offsetTop - _v374 - 15,
            'behavior': "smooth"
        });
    }
    footerSpacing () {
let _v375 = document.querySelector(".sticky-atc-footer-spacer");
        if (_v375)
            return;
        _v375 = document.createElement("div"),
        _v375.className = 'sticky-atc-footer-spacer',
        _v375.style.height = this.clientHeight - 1 + 'px',
        _v375.style.display = "block";
        const _v376 = document.querySelector(".footer");
        if (_v376)
            _v375.style.background = window.getComputedStyle(_v376).background;
        document.body.appendChild(_v375);
    }
}
customElements.define("sticky-atc", StickyAtc),
(function() {})();
class BundleDeals extends HTMLElement {
    constructor() {
super(),
        this.productContainers = this.querySelectorAll(".bundle-deals__product-js"),
        this.mediaItemContainers = this.querySelectorAll('.bundle-deals__media-item-container-js'),
        this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img-js"),
        this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js"),
        this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js"),
        this.skipNonExistent = this.dataset.skipNonExistent === "true",
        this.skipUnavailable = this.dataset.skipUnavailable === "true",
        this.prices = this.querySelectorAll(".bundle-deals__price-js"),
        this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js"),
        this.totalPrice = this.querySelector(".bundle-deals__total-price-js"),
        this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js"),
        this.updatePrices = this.dataset.updatePrices === "true",
        this.percentageLeft = parseFloat(this.dataset.percentageLeft),
        this.fixedDiscount = parseFloat(this.dataset.fixedDiscount),
        this.currencySymbol = this.dataset.currencySymbol,
        this.selectedVariants = {
            'id_1': null,
            'id_2': null,
            'id_3': null,
            'id_4': null,
            'id_5': null
        },
        this.formVariants = [],
        this.initIds(),
        this.checkboxes.forEach(_v377 => {
_v377.addEventListener("change", this.handleCheckboxChange.bind(this));
        }
        ),
        this.variantPickers.forEach(_v378 => {
_v378.addEventListener("change", this.handleSelectChange.bind(this));
        }
        );
    }
    initIds () {
this.checkboxes.forEach(_v379 => {
this.selectedVariants[_v379.dataset.idIndex] = {
                'id': _v379.dataset.id,
                'price': _v379.dataset.price,
                'comparePrice': _v379.dataset.comparePrice,
                'checked': true
            };
        }
        ),
        this.updateFormIds();
    }
    handleCheckboxChange (_v380) {
let _v381 = _v380.currentTarget
          , _v382 = _v381.checked
          , _v383 = parseInt(_v381.dataset.index);
        this.selectedVariants[_v381.dataset.idIndex].checked = _v382;
        const _v384 = this.productContainers[_v383]
          , _v385 = _v384.querySelectorAll("select");
        _v382 ? (this.mediaItemContainers[_v383].classList.remove("bundle-deals__media-item--disabled"),
        _v384.classList.remove('bundle-deals__product--deselected'),
        _v385.forEach(_v386 => {
_v386.removeAttribute("disabled");
        }
        )) : (this.mediaItemContainers[_v383].classList.add('bundle-deals__media-item--disabled'),
        _v384.classList.add('bundle-deals__product--deselected'),
        _v385.forEach(_v387 => {
_v387.setAttribute("disabled", '');
        }
        ));
        this.updateFormIds();
        if (this.updatePrices)
            this.updateTotalPrice();
    }
    handleSelectChange (_v388) {
let _v389 = _v388.currentTarget
          , _v390 = parseInt(_v389.dataset.index)
          , _v391 = Array.from(_v389.querySelectorAll("select"), _v392 => _v392.value)
          , _v393 = JSON.parse(_v389.querySelector("[type=\"application/json\"]").textContent).filter(_v394 => _v389.querySelector(':checked').value === _v394.option1)
          , _v395 = [..._v389.querySelectorAll('.select--small')];
        updateVariantStatuses(_v393, _v395);
        const _v396 = JSON.parse(_v389.querySelector('[type=\x22application/json\x22]').textContent).find(_v397 => {
return !_v397.options.map( (_v398, _v399) => {
                return _v391[_v399] === _v398;
            }
            ).includes(false);
        }
        );
        if (!_v396) {
            if (this.skipNonExistent)
                findAvailableVariant(_v389, _v391, false, true, this.skipUnavailable);
            return;
        }
        if (this.skipUnavailable && !_v396.available) {
            if (findAvailableVariant(_v389, _v391, false, true, true))
                return;
        }
        let {price: _v400, compare_at_price: _v401, featured_image: _v402} = _v396;
        _v400 = parseInt(_v400);
        let _v403 = _v401 ? parseInt(_v401) : _v400;
        const _v404 = _v389.dataset.percentageLeft ?? 1
          , _v405 = _v389.dataset.fixedDiscount ?? 0;
        _v400 = _v400 * _v404 - _v405;
        if (_v402)
            _v402 = _v402.src;
        const _v406 = _v396.id;
        this.selectedVariants[_v389.dataset.idIndex].id = _v406,
        this.selectedVariants[_v389.dataset.idIndex].price = _v400,
        this.selectedVariants[_v389.dataset.idIndex].comparePrice = _v403,
        this.updateFormIds(),
        this.updatePrices && (this.prices[_v390].innerHTML = this.currencySymbol + (_v400 / 100).toFixed(2),
        _v403 > _v400 ? this.comparePrices[_v390].innerHTML = this.currencySymbol + (_v403 / 100).toFixed(2) : this.comparePrices[_v390].innerHTML = '',
        this.updateTotalPrice()),
        _v402 && _v402.length > 0 && this.mediaItemImgs[_v390] && (this.mediaItemImgs[_v390].src = _v402);
    }
    updateFormIds () {
let _v407 = []
          , _v408 = this.selectedVariants;
        for (const _v409 in _v408) {
            const _v410 = _v408[_v409];
            if (_v410 != null && _v410.checked) {
                const _v411 = _v407.findIndex(_v412 => _v412.id === _v410.id);
                _v411 < 0 ? _v407.unshift({
                    'id': _v410.id,
                    'quantity': 1
                }) : _v407[_v411].quantity += 1;
            }
        }
        this.formVariants = _v407;
    }
    updateTotalPrice () {
let _v413 = []
          , _v414 = []
          , _v415 = this.selectedVariants;
        for (const _v416 in _v415) {
            const _v417 = _v415[_v416];
            _v417 != null && _v417.checked && (_v413.push(parseInt(_v417.price)),
            _v414.push(parseInt(_v417.comparePrice)));
        }
        const _v418 = _v413.reduce( (_v419, _v420) => _v419 + _v420, 0)
          , _v421 = _v418 * this.percentageLeft - this.fixedDiscount
          , _v422 = _v414.reduce( (_v423, _v424) => _v423 + _v424, 0);
        this.totalPrice.innerHTML = this.currencySymbol + (_v421 / 100).toFixed(2),
        _v422 > _v421 ? this.totalComparePrice.innerHTML = this.currencySymbol + (_v422 / 100).toFixed(2) : this.totalComparePrice.innerHTML = '';
    }
}
customElements.define('bundle-deals', BundleDeals);
class QuantityBreaks extends HTMLElement {
    constructor() {
super(),
        this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section),
        this.inputs = this.querySelectorAll('input[name=\x22quantity\x22]'),
        this.labels = this.querySelectorAll(".quantity-break"),
        this.jsonData = this.querySelector('[type=\x22application/json\x22]'),
        this.hasVariants = this.jsonData.dataset.hasVariants === "true",
        this.selectedVariants = {
            'input_1': [],
            'input_2': [],
            'input_3': [],
            'input_4': [],
            'input_5': [],
            'input_6': []
        },
        this.updateUnavailable = this.dataset.updateUnavailable === "true",
        this.skipNonExistent = this.dataset.skipNonExistent === "true",
        this.skipUnavailable = this.dataset.skipUnavailable === "true",
        this.formVariants = [],
        this.selectedQuantity = 1;
        if (this.querySelector("input[checked]"))
            this.selectedQuantity = parseInt(this.querySelector("input[checked]").value);
        this.variantSelects = this.querySelectorAll(".quantity-break__selector-item"),
        this.updatePrices = this.dataset.updatePrices === "true",
        this.moneyFormat = this.dataset.moneyFormat;
        if (this.hasVariants)
            this.initVariants();
        this.inputs.forEach(_v425 => {
_v425.addEventListener("change", this.handleChange.bind(this));
        }
        ),
        this.variantSelects.forEach(_v426 => {
_v426.addEventListener("change", this.handleSelectChange.bind(this));
        }
        );
    }
    handleSelectChange (_v427) {
let _v428 = _v427.currentTarget
          , _v429 = Array.from(_v428.querySelectorAll('select'), _v430 => _v430.value);
        if (this.updateUnavailable) {
            const _v431 = this.getVariantData().filter(_v432 => _v428.querySelector(":checked").value === _v432.option1)
              , _v433 = [..._v428.querySelectorAll(".select--small")];
            updateVariantStatuses(_v431, _v433);
        }
        const _v434 = this.getVariantData().find(_v435 => {
return !_v435.options.map( (_v436, _v437) => {
                return _v429[_v437] === _v436;
            }
            ).includes(false);
        }
        );
        if (!_v434) {
            if (this.skipNonExistent)
                findAvailableVariant(_v428, _v429, false, true, this.skipUnavailable);
            return;
        }
        if (this.skipUnavailable && !_v434.available) {
            if (findAvailableVariant(_v428, _v429, false, true, true))
                return;
        }
        _v428.dataset.selectedId = _v434.id;
        const _v438 = _v428.dataset.selectIndex
          , _v439 = _v428.closest(".quantity-break")
          , _v440 = _v439.dataset.input;
        this.selectedVariants[_v440][_v438] = _v434.id,
        this.formVariants = this.selectedVariants[_v440],
        this.updateMedia(_v434);
        if (!this.updatePrices)
            return;
        var _v441 = 0
          , _v442 = 0;
        const _v443 = parseFloat(_v439.dataset.quantity)
          , _v444 = parseFloat(_v439.dataset.percentageLeft)
          , _v445 = parseFloat(_v439.dataset.fixedDiscount);
        for (let _v446 = 0; _v446 < _v443; _v446++) {
            const _v447 = parseInt(this.selectedVariants[_v440][_v446])
              , _v448 = this.getVariantData().find(_v449 => parseInt(_v449.id) === _v447);
            if (!_v448)
                return;
            _v441 += _v448.price,
            _v448.compare_at_price && _v448.compare_at_price > _v448.price ? _v442 += _v448.compare_at_price : _v442 += _v448.price;
        }
        _v441 = _v441 * _v444 - _v445;
        const _v450 = _v442 - _v441
          , _v451 = Math.round(_v450 / 100) * 100
          , _v452 = _v441 / _v443
          , _v453 = _v442 / _v443
          , _v454 = formatMoney(_v441, this.moneyFormat, true)
          , _v455 = formatMoney(_v442, this.moneyFormat, true)
          , _v456 = formatMoney(_v450, this.moneyFormat, true)
          , _v457 = formatMoney(_v451, this.moneyFormat, true)
          , _v458 = formatMoney(_v452, this.moneyFormat, true)
          , _v459 = formatMoney(_v453, this.moneyFormat, true);
        _v439.querySelectorAll(".variant-price-update").forEach(_v460 => {
let _v461 = _v460.dataset.text;
            _v461 = _v461.replace('[quantity]', _v443),
            _v461 = _v461.replace("[price]", _v454),
            _v461 = _v461.replace("[compare_price]", _v455),
            _v461 = _v461.replace("[amount_saved]", _v456),
            _v461 = _v461.replace('[amount_saved_rounded]', _v457),
            _v461 = _v461.replace("[price_each]", _v458),
            _v461 = _v461.replace("[compare_price_each]", _v459),
            _v460.innerHTML = _v461;
        }
        );
        const _v462 = _v439.querySelector(".quantity-break__compare-price");
        _v462 && (_v442 > _v441 ? _v462.classList.remove("hidden") : _v462.classList.add('hidden'));
    }
    getVariantData () {
return this.variantData = this.variantData || JSON.parse(this.jsonData.textContent),
        this.variantData;
    }
    initVariants () {
if (!this.hasVariants)
            return;
        this.labels.forEach(_v463 => {
if (_v463.querySelector(".quantity-break__variants")) {
                let _v464 = [];
                _v463.querySelectorAll(".quantity-break__selector-item").forEach(_v465 => {
_v464.push(_v465.dataset.selectedId);
                }
                ),
                this.selectedVariants[_v463.dataset.input] = _v464;
            }
        }
        ),
        this.formVariants = [];
    }
    updateMedia (_v466) {
if (!_v466)
            return;
        if (!_v466.featured_media)
            return;
        const _v467 = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + '\x22]');
        _v467.forEach(_v468 => _v468.setActiveMedia(this.dataset.section + '-' + _v466.featured_media.id, true));
    }
    handleChange (_v469) {
let _v470 = parseInt(_v469.target.value);
        this.selectedQuantity = _v470;
        if (this.hasVariants)
            this.formVariants = this.selectedVariants[_v469.target.dataset.input];
        if (this.quantityGifts)
            this.quantityGifts.unlockGifts(_v470);
    }
}
customElements.define("quantity-breaks", QuantityBreaks);
function metafieldPoly() {
    return true;
}
function updateVariantStatuses(_v471, _v472) {
_v472.forEach( (_v473, _v474) => {
if (_v474 === 0)
            return;
        const _v475 = [..._v473.querySelectorAll("option")]
          , _v476 = _v472[_v474 - 1].querySelector(":checked").value
          , _v477 = _v471.filter(_v478 => _v478.available && _v478["option" + _v474] === _v476).map(_v479 => _v479['option' + (_v474 + 1)])
          , _v480 = _v471.filter(_v481 => _v481["option" + _v474] === _v476).map(_v482 => _v482["option" + (_v474 + 1)]);
        _v475.forEach(_v483 => {
_v483.classList.remove("unavailable", "non-existent"),
            _v480.includes(_v483.getAttribute("value")) ? _v477.includes(_v483.getAttribute('value')) ? _v483.innerText = _v483.getAttribute("value") : (_v483.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _v483.getAttribute('value')),
            _v483.classList.add("unavailable")) : (_v483.innerText = window.variantStrings.unavailable_with_option.replace('[value]', _v483.getAttribute("value")),
            _v483.classList.add("non-existent"));
        }
        );
    }
    );
}
function findAvailableVariant(_v484, _v485, _v486=true, _v487=false, _v488=false) {
console.log("Running findAvailableVariant");
    for (let _v489 = _v485.length - 1; _v489 >= 0; _v489--) {
        const _v490 = _v486 ? _v484.querySelector(".product-form__input:nth-child(" + (_v489 + 1) + ')') : _v484.querySelectorAll('.select')[_v489]
          , _v491 = _v486 ? _v490.querySelector(".product-form__input__type").dataset.type : 'dropdown'
          , _v492 = _v491 === "dropdown" ? _v490.querySelectorAll("option") : _v490.querySelectorAll("input[type=\"radio\"]");
        let _v493 = Array.from(_v492).findIndex(_v494 => _v494.value === _v485[_v489])
          , _v495 = false;
        while (_v493 < _v492.length - 1) {
            _v493++;
            const _v496 = _v492[_v493];
            if ((!_v487 || !_v496.classList.contains("non-existent")) && (!_v488 || !_v496.classList.contains("unavailable"))) {
                _v485[_v489] = _v496.value,
                _v495 = true;
                break;
            }
        }
        if (!_v495) {
            _v493 = Array.from(_v492).findIndex(_v497 => _v497.value === _v485[_v489]);
            while (_v493 > 0) {
                _v493--;
                const _v498 = _v492[_v493];
                if ((!_v487 || !_v498.classList.contains("non-existent")) && (!_v488 || !_v498.classList.contains("unavailable"))) {
                    _v485[_v489] = _v498.value,
                    _v495 = true;
                    break;
                }
            }
        }
        if (_v495)
            return _v491 === "dropdown" ? _v490.querySelector('.select__select').value = _v485[_v489] : _v490.querySelector('input[type=\x22radio\x22][value=\x22' + _v485[_v489] + '\x22]').checked = true,
            _v484.dispatchEvent(new Event("change")),
            true;
    }
    return false;
}
class QuantityGifts extends HTMLElement {
    constructor() {
super(),
        this.gifts = this.querySelectorAll(".quantity-gift"),
        this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section),
        this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section),
        this.unlockedItems = [],
        this.initUnlock();
    }
    initUnlock () {
let _v499 = 1;
        if (this.quantityBreaks)
            _v499 = parseInt(this.quantityBreaks.selectedQuantity);
        else {
            if (this.quantitySelector) {
                const _v500 = this.quantitySelector.querySelector('input[name=\x22quantity\x22]');
                _v499 = parseInt(_v500.value);
            }
        }
        this.unlockGifts(_v499);
    }
    unlockGifts (_v501) {
this.unlockedItems = [],
        this.gifts.forEach(_v502 => {
parseInt(_v502.dataset.quantity) <= _v501 ? (_v502.classList.add("quantity-gift--unlocked"),
            _v502.dataset.unlocked = "true",
            this.unlockedItems.unshift(_v502.dataset.product)) : (_v502.classList.remove("quantity-gift--unlocked"),
            _v502.dataset.unlocked = 'false');
        }
        );
    }
}
customElements.define("quantity-gifts", QuantityGifts);
class ProductInfoUpsell extends HTMLElement {
    constructor() {
super(),
        this.image = this.querySelector(".upsell__image__img"),
        this.toggleBtn = this.querySelector(".upsell-toggle-btn"),
        this.variantSelects = this.querySelector(".upsell__variant-picker"),
        this.variantSelectElements = this.querySelectorAll(".select__select"),
        this.jsonData = this.querySelector('[type=\x22application/json\x22]'),
        this.skipNonExistent = this.dataset.skipNonExistent === "true",
        this.skipUnavailable = this.dataset.skipUnavailable === "true",
        this.updatePrices = this.dataset.updatePrices === "true";
        if (this.updatePrices) {
            this.price = parseInt(this.dataset.price),
            this.comparePrice = parseInt(this.dataset.comparePrice),
            this.priceSpan = this.querySelector('.upsell__price\x20.regular-price'),
            this.comparePriceSpan = this.querySelector('.upsell__price\x20.compare-price'),
            this.percentageLeft = parseFloat(this.dataset.percentageLeft),
            this.fixedDiscount = parseFloat(this.dataset.fixedDiscount),
            this.moneyFormat = this.dataset.moneyFormat,
            this.isMainOfferItem = this.dataset.mainOfferItem === "true";
            if (this.isMainOfferItem)
                this.mainOfferContainer = document.querySelector("#MainBundleOffer-" + this.dataset.section);
        }
        if (this.toggleBtn)
            this.toggleBtn.addEventListener("click", this.handleToggle.bind(this));
        if (this.variantSelects)
            this.variantSelects.addEventListener("change", this.handleSelectChange.bind(this));
    }
    handleToggle (_v503) {
if (_v503.target.nodeName.toLowerCase() === "select" || _v503.target.nodeName.toLowerCase() === 'option')
            return;
        this.dataset.selected === "true" ? this.dataset.selected = "false" : this.dataset.selected = "true";
    }
    handleSelectChange (_v504) {
let _v505 = _v504.currentTarget
          , _v506 = Array.from(_v505.querySelectorAll('select'), _v507 => _v507.value)
          , _v508 = this.getVariantData().find(_v509 => {
return !_v509.options.map( (_v510, _v511) => {
                return _v506[_v511] === _v510;
            }
            ).includes(false);
        }
        )
          , _v512 = this.getVariantData().filter(_v513 => _v505.querySelector(":checked").value === _v513.option1)
          , _v514 = [..._v505.querySelectorAll("select")];
        updateVariantStatuses(_v512, _v514);
        if (!_v508) {
            if (this.skipNonExistent)
                findAvailableVariant(_v505, _v506, false, true, this.skipUnavailable);
            return;
        }
        if (this.skipUnavailable && !_v508.available) {
            if (findAvailableVariant(_v505, _v506, false, true, true))
                return;
        }
        this.updatePrices && (this.price = _v508.price * this.percentageLeft - this.fixedDiscount,
        this.comparePrice = _v508.price,
        _v508.compare_at_price && _v508.compare_at_price > _v508.price && (this.comparePrice = _v508.compare_at_price),
        displayPrices(this.price, this.comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat));
        if (this.image && _v508.featured_image)
            this.image.src = _v508.featured_image.src;
        this.updateId(_v508.id);
        if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices)
            this.mainOfferContainer.updateTotalPrices();
    }
    updateId (_v515) {
this.dataset.id = _v515;
    }
    getVariantData () {
return this.variantData = this.variantData || JSON.parse(this.jsonData.textContent),
        this.variantData;
    }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
    constructor() {
super(),
        this.cartDrawer = document.querySelector('cart-drawer'),
        this.cartItems = this.cartDrawer.querySelector("cart-drawer-items"),
        this.productForm = this.querySelector('product-form'),
        this.idInput = this.productForm.querySelector("[name=\"id\"]"),
        this.classicAddButton = this.querySelector('.upsell__add-btn');
    }
    handleToggle (_v516) {
if (_v516.target.nodeName.toLowerCase() === 'select' || _v516.target.nodeName.toLowerCase() === 'option')
            return;
        this.dataset.selected === "true" ? (this.dataset.selected = "false",
        this.removeFromCart()) : (this.dataset.selected = 'true',
        this.addToCart());
    }
    addRemoveFromCart () {
this.dataset.selected === "true" && !this.cartDrawer.classList.contains('is-empty') ? this.addToCart() : this.removeFromCart();
    }
    addToCart () {
let _v517 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
        if (_v517)
            return;
        if (this.toggleBtn)
            this.toggleBtn.setAttribute('disabled', '');
        this.variantSelectElements.forEach(_v518 => {
_v518.setAttribute('disabled', '');
        }
        ),
        this.productForm.handleSubmit();
    }
    removeFromCart () {
let _v519 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
        if (!_v519 || !this.cartItems)
            return;
        if (this.toggleBtn)
            this.toggleBtn.setAttribute("disabled", '');
        this.variantSelectElements.forEach(_v520 => {
_v520.setAttribute("disabled", '');
        }
        ),
        this.cartItems.updateQuantity(_v519.dataset.index, 0);
    }
    updateId (_v521) {
this.dataset.id = _v521,
        this.idInput.value = _v521;
        if (this.classicAddButton)
            return;
        if (this.dataset.selected === "true") {
            this.selectTimeout && clearTimeout(this.selectTimeout);
            this.removeFromCart();
            const _v522 = _v523 => {
_v523.detail.handle === "handle" && (this.addToCart(),
                document.removeEventListener('cartQuantityUpdated', _v522));
            }
            ;
            document.addEventListener("cartQuantityUpdated", _v522);
        }
    }
    getUpdateRequired () {
let _v524 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
        let _v525 = false;
        if (_v524 && this.dataset.selected === 'false')
            _v525 = true;
        else
            !_v524 && this.dataset.selected === "true" && (_v525 = true);
        return _v525;
    }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
function displayPrices(_v526, _v527, _v528, _v529, _v530) {
if (!_v530)
        return;
    if (_v526 && _v528) {
        var _v531 = formatMoney(_v526, _v530);
        _v528.innerHTML = _v531;
    }
    if (_v527 && _v529) {
        var _v532 = formatMoney(_v527, _v530);
        _v529.innerHTML = _v532,
        _v527 > _v526 ? _v529.classList.remove("hidden") : _v529.classList.add("hidden");
    }
}
function initTrapFocus() {
isIe = false;
    if (document.querySelector('footer') && document.querySelector("footer").dataset['t' + 'y' + 'p' + 'e'] === null)
        return false;
    return true;
}
function formatMoney(_v533, _v534, _v535=false) {
typeof _v533 == 'string' && (_v533 = _v533.replace('.', ''));
    var _v536 = ''
      , _v537 = /\{\{\s*(\w+)\s*\}\}/
      , _v538 = _v534;
    function _v539(_v540, _v541) {
        return typeof _v540 == 'undefined' ? _v541 : _v540;
    }
    function _v542(_v543, _v544, _v545, _v546) {
_v544 = _v539(_v544, 2),
        _v545 = _v539(_v545, ','),
        _v546 = _v539(_v546, '.');
        if (isNaN(_v543) || _v543 == null)
            return 0;
        _v543 = (_v543 / 100).toFixed(_v544);
        var _v547 = _v543.split('.')
          , _v548 = _v547[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + _v545)
          , _v549 = _v547[1] ? _v546 + _v547[1] : '';
        return _v535 && _v549 === _v546 + '00' && (_v549 = ''),
        _v548 + _v549;
    }
    switch (_v538.match(_v537)[1]) {
    case 'amount':
        _v536 = _v542(_v533, 2);
        break;
    case "amount_no_decimals":
        _v536 = _v542(_v533, 0);
        break;
    case 'amount_with_comma_separator':
        _v536 = _v542(_v533, 2, '.', ',');
        break;
    case "amount_no_decimals_with_comma_separator":
        _v536 = _v542(_v533, 0, '.', ',');
        break;
    }
    return _v538.replace(_v537, _v536);
}
class CartDrawerGift extends CartDrawerUpsell {
    constructor() {
        super();
    }
}
customElements.define("cart-drawer-gift", CartDrawerGift);
function initToggleUpsells() {
let _v550 = document.querySelector('cart-drawer');
    _v550 && _v550.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(_v551 => {
if (_v551.addRemoveFromCart)
            _v551.addRemoveFromCart();
    }
    );
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
    constructor() {
super(),
        this.offerItems = this.querySelectorAll(".main-offer-item"),
        this.updatePrices = this.dataset.updatePrices === "true",
        this.updatePrices && (this.priceSpan = this.querySelector(".bundle-deals__total-price-js"),
        this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js"),
        this.percentageLeft = parseFloat(this.dataset.percentageLeft),
        this.fixedDiscount = parseFloat(this.dataset.fixedDiscount),
        this.moneyFormat = this.dataset.moneyFormat);
    }
    updateTotalPrices () {
if (!this.updatePrices)
            return;
        var _v552 = 0
          , _v553 = 0;
        for (let _v554 = 0; _v554 < this.offerItems.length; _v554++) {
            _v552 += parseInt(this.offerItems[_v554].price),
            _v553 += parseInt(this.offerItems[_v554].comparePrice);
        }
        _v552 = _v552 * this.percentageLeft - this.fixedDiscount,
        displayPrices(_v552, _v553, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
    }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback () {
this.fieldName = this.dataset.name,
        this.input = this.querySelector("[type=\"text\"], [type=\"number\"], textarea"),
        this.inputRadios = this.querySelectorAll('[type=\x22radio\x22]'),
        this.select = this.querySelector('.select__select'),
        this.productForm = document.getElementById("product-form-" + this.dataset.section),
        this.prevValue = this.dataset.defaultValue,
        this.isRequired = this.dataset.required === "true",
        this.isText = true,
        this.notMain = this.dataset.notMain === 'true';
        if (this.dataset.type === "select" || this.dataset.type === "pills")
            this.isText = false;
        this.createInputs();
        this.isRequired && this.isText && (this.isValid = true,
        this.atcButtons = this.notMain ? document.querySelectorAll('.featured-product-atc-' + this.dataset.section) : document.querySelectorAll(".main-product-atc"),
        this.mainAtcButton = this.productForm.querySelector('#ProductSubmitButton-' + this.dataset.section),
        this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label"),
        this.mainAtcBtnError = this.mainAtcButton.querySelector('.main-atc__error'),
        this.atcErrorMsg = this.dataset.atcErrorMsg,
        this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 1,
        this.mainAtcBtnError.innerHTML = this.atcErrorMsg,
        this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true",
        this.stickyAtcButton = document.querySelector('#sticky-atc-' + this.dataset.section),
        this.applyStickyAtcError && this.stickyAtcButton && (this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector('.sticky-atc__label'),
        this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error"),
        this.stickyAtcBtnError.innerHTML = this.atcErrorMsg),
        this.validateValue(this.prevValue, null));
        if (this.input)
            this.input.addEventListener("input", this.handleChange.bind(this));
        this.inputRadios.forEach(_v555 => {
_v555.addEventListener("input", this.handleChange.bind(this));
        }
        );
        if (this.select)
            this.select.addEventListener("change", this.handleChange.bind(this));
    }
    handleChange (_v556) {
let _v557 = _v556.target.value.trim();
        if (_v556.target.checkValidity())
            this.prevValue = _v557;
        else {
            _v556.target.value = this.prevValue;
            return;
        }
        this.dataset.value = _v557,
        this.productFormInput.value = _v557;
        if (this.isRequired && this.isText)
            this.validateValue(_v557, _v556.target);
    }
    validateValue (_v558, _v559) {
let _v560 = _v558.length > 0 ? true : false;
        if (_v560 === this.isValid)
            return;
        this.isValid = _v560;
        _v559 && (this.isValid ? (_v559.classList.remove("input--error"),
        this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 1) : (_v559.classList.add("input--error"),
        this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 1));
        const _v561 = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields
          , _v562 = this.mainAtcButton.dataset.unavailable === "true";
        this.atcButtons.forEach(_v563 => {
_v561 && !_v562 ? _v563.removeAttribute("disabled") : _v563.setAttribute("disabled", '');
        }
        );
        if (this.atcErrorMsg.length === 0)
            return;
        _v561 ? (this.mainAtcBtnLabel.style.display = '',
        this.mainAtcBtnError.style.display = "none",
        this.applyStickyAtcError && this.stickyAtcButton && (this.stickyAtcBtnLabel.style.display = '',
        this.stickyAtcBtnError.style.display = "none")) : (this.mainAtcBtnLabel.style.display = "none",
        this.mainAtcBtnError.style.display = '',
        this.applyStickyAtcError && this.stickyAtcButton && (this.stickyAtcBtnLabel.style.display = 'none',
        this.stickyAtcBtnError.style.display = ''));
    }
    createInputs () {
this.productFormInput = document.createElement("input"),
        this.productFormInput.setAttribute("type", 'hidden'),
        this.productFormInput.setAttribute("name", "properties[" + this.fieldName + ']'),
        this.productFormInput.value = this.dataset.defaultValue,
        this.productForm.appendChild(this.productFormInput);
    }
}
customElements.define("custom-product-field", CustomProductField);
function playMedia() {
if (!serial)
        serial = document.currentScript.dataset.animationsType || '';
}
class VariantSelects extends HTMLElement {
    constructor() {
super(),
        this.secondarySelectSelector = "StickyAtcVariantPicker-",
        this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section),
        this.isSecondary = false,
        this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section),
        this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true",
        this.prependMedia = this.dataset.disablePrepend != "true",
        this.filtering = this.dataset.hasFiltering === "true",
        this.skipNonExistent = this.dataset.skipNonExistent === "true",
        this.skipUnavailable = this.dataset.skipUnavailable === "true",
        this.hasQuantityBreaksPicker && (this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle,
        this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages),
        this.addEventListener('change', this.onVariantChange);
    }
    onVariantChange () {
this.updateOptions(),
        this.updateMasterId(),
        this.toggleAddButton(true, '', false),
        this.updatePickupAvailability(),
        this.removeErrorMessage(),
        this.updateVariantStatuses();
        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            if (this.skipNonExistent && findAvailableVariant(this, this.options, true, true, this.skipUnavailable))
                return;
            this.setUnavailable();
        } else {
            if (this.skipUnavailable && !this.currentVariant.available) {
                if (findAvailableVariant(this, this.options, true, true, true))
                    return;
            }
            this.updateMedia(),
            this.updateURL(),
            this.updateVariantInput(),
            this.renderProductInfo(),
            this.updateShareUrl();
        }
    }
    updateOptions () {
let _v564 = [];
        this.querySelectorAll(".product-form__input").forEach(_v565 => {
let _v566;
            const _v567 = _v565.querySelector(".product-form__input__type").dataset.type;
            _v567 == 'dropdown' || _v567 == "dropdwon" ? _v566 = _v565.querySelector('.select__select').value : _v566 = _v565.querySelector("input[type=\"radio\"]:checked").value,
            _v564.push(_v566);
        }
        ),
        this.options = _v564;
    }
    updateMasterId () {
this.currentVariant = this.getVariantData().find(_v568 => {
return !_v568.options.map( (_v569, _v570) => {
return this.options[_v570] === _v569;
            }
            ).includes(false);
        }
        );
    }
    updateMedia () {
if (!this.currentVariant)
            return;
        if (!this.currentVariant.featured_media)
            return;
        const _v571 = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + '\x22]');
        _v571.forEach(_v572 => _v572.setActiveMedia(this.dataset.section + '-' + this.currentVariant.featured_media.id, this.prependMedia, this.filtering, this.currentVariant));
        const _v573 = document.querySelector("#ProductModal-" + this.dataset.section + " .product-media-modal__content");
        if (!_v573)
            return;
        const _v574 = _v573.querySelector('[data-media-id=\x22' + this.currentVariant.featured_media.id + '\x22]');
        _v573.prepend(_v574);
    }
    updateURL () {
if (!this.currentVariant || this.dataset.updateUrl === "false")
            return;
        window.history.replaceState({}, '', this.dataset.url + "?variant=" + this.currentVariant.id);
    }
    updateShareUrl () {
let _v575 = document.getElementById('Share-' + this.dataset.section);
        if (!_v575 || !_v575.updateUrl)
            return;
        _v575.updateUrl('' + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
    }
    updateVariantInput () {
let _v576 = document.querySelectorAll('#product-form-' + this.dataset.section + ',\x20#product-form-installment-' + this.dataset.section);
        _v576.forEach(_v577 => {
let _v578 = _v577.querySelector("input[name=\"id\"]");
            _v578.value = this.currentVariant.id,
            _v578.dispatchEvent(new Event("change",{
                'bubbles': true
            }));
        }
        );
    }
    updateVariantStatuses () {
let _v579 = this.variantData.filter(_v580 => this.querySelector(":checked").value === _v580.option1);
        let _v581;
        this.isSecondary && this.secondarySelect ? _v581 = [...this.secondarySelect.querySelectorAll('.product-form__input')] : _v581 = [...this.querySelectorAll(".product-form__input")],
        _v581.forEach( (_v582, _v583) => {
if (_v583 === 0)
                return;
            const _v584 = [..._v582.querySelectorAll("input[type=\"radio\"], .select__select option")]
              , _v585 = _v581[_v583 - 1].querySelector(":checked").value
              , _v586 = _v579.filter(_v587 => _v587.available && _v587['option' + _v583] === _v585).map(_v588 => _v588["option" + (_v583 + 1)])
              , _v589 = _v579.filter(_v590 => _v590["option" + _v583] === _v585).map(_v591 => _v591["option" + (_v583 + 1)]);
            this.setInputAvailability(_v584, _v586, _v589);
        }
        );
    }
    setInputAvailability (_v592, _v593, _v594) {
        _v592.forEach(_v595 => {
_v595.classList.remove("unavailable", 'non-existent', 'disabled');
            const _v596 = _v595.getAttribute("value");
            let _v597 = null;
            _v595.dataset.swatch === "true" && (_v597 = _v595.closest(".color-swatch"));
            if (_v597)
                _v597.classList.remove('unavailable', 'non-existent', 'disabled');
            if (_v594.includes(_v596)) {
                if (_v593.includes(_v596)) {
                    if (_v595.nodeName === "OPTION")
                        _v595.innerText = _v596;
                    else {
                        _v595.classList.remove("disabled");
                        if (_v597)
                            _v597.classList.remove("disabled");
                    }
                } else {
                    if (_v595.nodeName === "OPTION")
                        _v595.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _v596),
                        _v595.classList.add("unavailable");
                    else {
                        _v595.classList.add('disabled', "unavailable");
                        if (_v597)
                            _v597.classList.add("disabled", "unavailable");
                    }
                }
            } else {
                if (_v595.nodeName === "OPTION")
                    _v595.innerText = window.variantStrings.unavailable_with_option.replace('[value]', _v596),
                    _v595.classList.add("non-existent");
                else {
                    _v595.classList.add("disabled", 'non-existent');
                    if (_v597)
                        _v597.classList.add("disabled", "non-existent");
                }
            }
        }
        );
    }
    updatePickupAvailability () {
let _v598 = document.querySelector('pickup-availability');
        if (!_v598)
            return;
        if (this.currentVariant && this.currentVariant.available) {
            if (_v598.fetchAvailability)
                _v598.fetchAvailability(this.currentVariant.id);
        } else
            _v598.removeAttribute("available"),
            _v598.innerHTML = '';
    }
    removeErrorMessage () {
let _v599 = this.closest('section');
        if (!_v599)
            return;
        const _v600 = _v599.querySelector("product-form");
        if (_v600)
            _v600.handleErrorMessage();
    }
    renderProductInfo () {
let _v601 = this.currentVariant.id
          , _v602 = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        fetch(this.dataset.url + "?variant=" + _v601 + '&section_id=' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)).then(_v603 => _v603.text()).then(_v604 => {
if (this.currentVariant.id !== _v601)
                return;
            const _v605 = new DOMParser().parseFromString(_v604, "text/html")
              , _v606 = document.getElementById("price-" + this.dataset.section)
              , _v607 = _v605.getElementById('price-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section))
              , _v608 = document.getElementById("sticky-atc-separate-price-" + this.dataset.section)
              , _v609 = _v605.getElementById("sticky-atc-separate-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section))
              , _v610 = document.getElementById("sticky-atc-price-" + this.dataset.section)
              , _v611 = _v605.getElementById('sticky-atc-price-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section))
              , _v612 = document.getElementById("sticky-atc-image-" + this.dataset.section)
              , _v613 = _v605.getElementById('sticky-atc-image-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section))
              , _v614 = document.getElementById("main-atc-price-" + this.dataset.section)
              , _v615 = _v605.getElementById("main-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section))
              , _v616 = document.querySelectorAll('[id^=\x22custom-label-' + this.dataset.section + '\x22]')
              , _v617 = _v605.querySelectorAll("[id^=\"custom-label-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) + '\x22]')
              , _v618 = _v605.getElementById("Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section))
              , _v619 = document.getElementById("Sku-" + this.dataset.section)
              , _v620 = _v605.getElementById('Inventory-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section))
              , _v621 = document.getElementById("Inventory-" + this.dataset.section);
            if (_v606 && _v607)
                _v606.innerHTML = _v607.innerHTML;
            if (_v608 && _v609)
                _v608.innerHTML = _v609.innerHTML;
            if (_v610 && _v611)
                _v610.innerHTML = _v611.innerHTML;
            if (_v612 && _v613)
                _v612.src = _v613.src;
            if (_v615 && _v614)
                _v614.innerHTML = _v615.innerHTML;
            if (_v616 && _v617)
                for (var _v622 = 0; _v622 < _v616.length; _v622++) {
                    _v616[_v622].innerHTML = _v617[_v622].innerHTML;
                }
            if (_v620 && _v621)
                _v621.innerHTML = _v620.innerHTML;
            _v618 && _v619 && (_v619.innerHTML = _v618.innerHTML,
            _v619.classList.toggle("visibility-hidden", _v618.classList.contains("visibility-hidden")));
            if (this.QuantityBreaks) {
                const _v623 = _v605.getElementById("quantity-breaks-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section))
                  , _v624 = this.QuantityBreaks.querySelectorAll(".dynamic-price")
                  , _v625 = _v623.querySelectorAll('.dynamic-price');
                for (let _v626 = 0; _v626 < _v624.length; _v626++) {
                    _v624[_v626].innerHTML = _v625[_v626].innerHTML;
                }
                if (this.QuantityBreaks.hasVariants) {
                    this.QuantityBreaks.variantSelects.forEach(_v627 => {
_v627.dataset.selectedId = this.currentVariant.id;
                    }
                    );
                    const _v628 = this.QuantityBreaks.querySelectorAll('.quantity-break__variant-select')
                      , _v629 = _v623.querySelectorAll(".quantity-break__variant-select");
                    for (let _v630 = 0; _v630 < _v628.length; _v630++) {
                        _v628[_v630].innerHTML = _v629[_v630].innerHTML;
                    }
                    this.QuantityBreaks.initVariants();
                }
                ;
            }
            if (this.hasQuantityBreaksPicker) {
                const _v631 = _v605.getElementById("variant-selects-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section))
                  , _v632 = this.querySelectorAll(".dynamic-price")
                  , _v633 = _v631.querySelectorAll('.dynamic-price');
                for (let _v634 = 0; _v634 < _v632.length; _v634++) {
                    _v632[_v634].innerHTML = _v633[_v634].innerHTML;
                }
                if (this.quantityBreaksPickerStyle === 'vertical' && this.quantityBreaksPickerDisplayedImages === "variant_images") {
                    const _v635 = this.querySelectorAll('.quantity-break__image\x20img')
                      , _v636 = _v631.querySelectorAll(".quantity-break__image img");
                    for (let _v637 = 0; _v637 < _v635.length; _v637++) {
                        _v635[_v637].src = _v636[_v637].src;
                    }
                }
            }
            if (this.secondarySelect) {
                const _v638 = _v605.getElementById('' + this.secondarySelectSelector + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
                if (_v638)
                    this.secondarySelect.innerHTML = _v638.innerHTML;
            }
            const _v639 = document.getElementById("price-" + this.dataset.section);
            if (_v639)
                _v639.classList.remove('visibility-hidden');
            if (_v621)
                _v621.classList.toggle("visibility-hidden", _v620.innerText === '');
            const _v640 = _v605.getElementById("ProductSubmitButton-" + _v602);
            this.toggleAddButton(_v640 ? _v640.hasAttribute('disabled') : true, window.variantStrings.soldOut),
            publish(PUB_SUB_EVENTS.variantChange, {
                'data': {
                    'sectionId': _v602,
                    'html': _v605,
                    'variant': this.currentVariant
                }
            });
        }
        );
    }
    toggleAddButton (_v641=true, _v642, _v643=true) {
let _v644 = document.getElementById("product-form-" + this.dataset.section);
        if (!_v644)
            return;
        const _v645 = _v644.querySelector("[name=\"add\"]")
          , _v646 = document.querySelectorAll('.main-product-atc');
        var _v647 = _v644.querySelector(".main-atc__label__text");
        if (!_v647)
            _v647 = _v644.querySelector(".main-atc__label");
        const _v648 = _v644.querySelector(".main-atc-price");
        if (!_v645)
            return;
        if (_v641) {
            _v645.setAttribute("disabled", 'disabled'),
            _v645.setAttribute('data-unavailable', "true");
            if (_v642)
                _v647.textContent = _v642;
            _v646.forEach(_v649 => {
_v649.setAttribute("disabled", "disabled");
            }
            );
            if (_v648)
                _v648.classList.add("hidden");
        } else {
            _v645.setAttribute("data-unavailable", "false"),
            _v647.textContent = window.variantStrings.addToCart;
            if (_v648)
                _v648.classList.remove('hidden');
            _v645.dataset.requiredFields === _v645.dataset.validFields && (_v645.removeAttribute("disabled"),
            _v646.forEach(_v650 => {
_v650.removeAttribute('disabled');
            }
            ));
        }
        if (!_v643)
            return;
    }
    setUnavailable () {
let _v651 = document.getElementById('product-form-' + this.dataset.section);
        if (!_v651)
            return;
        const _v652 = _v651.querySelector("[name=\"add\"]");
        var _v653 = _v651.querySelector(".main-atc__label__text");
        if (!_v653)
            _v653 = _v651.querySelector(".main-atc__label");
        const _v654 = document.getElementById("price-" + this.dataset.section)
          , _v655 = document.getElementById("Inventory-" + this.dataset.section)
          , _v656 = document.getElementById("Sku-" + this.dataset.section);
        if (!_v652)
            return;
        _v653.textContent = window.variantStrings.unavailable;
        if (_v654)
            _v654.classList.add('visibility-hidden');
        if (_v655)
            _v655.classList.add("visibility-hidden");
        if (_v656)
            _v656.classList.add("visibility-hidden");
    }
    getVariantData () {
return this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent),
        this.variantData;
    }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
    constructor() {
super(),
        this.secondarySelectSelector = 'variant-selects-',
        this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section),
        this.isSecondary = true;
    }
    updateOptions () {
this.options = this.querySelector("select").value.split(',');
    }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
    constructor() {
super(),
        this.secondarySelectSelector = 'variant-selects-',
        this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section),
        this.isSecondary = true;
    }
}
customElements.define('secondary-variant-select-separate', SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
    constructor() {
super(),
        this.quickAddSubmit = document.getElementById(this.dataset.section + '-submit');
    }
    onVariantChange () {
this.updateOptions(),
        this.updateMasterId(),
        this.toggleAddButton(true, '', false),
        this.updateVariantStatuses(),
        !this.currentVariant ? (this.toggleAddButton(true, '', true),
        this.setUnavailable()) : (this.updateMedia(),
        this.updateVariantInput(),
        this.updateQuickAddUrl(),
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut));
    }
    updateMedia () {
if (!this.currentVariant || !this.currentVariant.featured_media)
            return;
        const _v657 = document.getElementById(this.dataset.section + "-image");
        if (!_v657)
            return;
        const _v658 = this.currentVariant.featured_media.preview_image
          , _v659 = _v658.src.split('?')[0]
          , _v660 = [165, 360, 533, 720, 940, 1066]
          , _v661 = _v660.filter(_v662 => _v658.width >= _v662).map(_v663 => _v659 + "?width=" + _v663 + '\x20' + _v663 + 'w').join(',\x20');
        _v657.srcset = _v661 + ',\x20' + _v659 + '\x20' + _v658.width + 'w',
        _v657.src = _v659 + "?width=533";
    }
    updateQuickAddUrl () {
if (!this.currentVariant || !this.quickAddSubmit)
            return;
        this.quickAddSubmit.dataset.productUrl = this.dataset.url + "?variant=" + this.currentVariant.id;
    }
}
customElements.define("card-variant-selects", CardVariantSelects);
